import React, { useState } from 'react';
import { Card, Steps, Tabs, Space, Button, Table, Tag, Form, Checkbox, Radio, Divider, Typography, Drawer, Select, Upload, Input, message, Switch, Tooltip, Alert, InputNumber, Row, Col, TimePicker } from 'antd';
import dayjs from 'dayjs';
import { ArrowLeftOutlined, EditOutlined, InfoCircleOutlined, InboxOutlined } from '@ant-design/icons';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import './ProductDetail.css';

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const ProductDetail = ({ hideHeader = false }) => {
    /*
    ========================================================================================================================================
    算法联动配置全量表 (整理自代码逻辑)
    ========================================================================================================================================
    | ID(AIIoTType) | 算法名称 | 服务ID | 描述 | 算法配置(详细字段及关联) | 关联事件(ID、名称、描述) |
    |---------------|---------|--------|------|------------------------|------------------------|
    | 1000 | 人形/运动检测 | 300026,300027 | 检测画面中的人形或移动物体 | 无特殊配置 | 100000 移动检测:监测画面中像素发生位移变化; 100001 人形识别:智能过滤非人物体，精确识别人物 |
    | 1003 | PIR红外检测 | 300048 | 基于红外热释电的人体活动监测 | 默认开关、灵敏度(20-100)、智能追踪开关、声音报警(1009)、设备报警灯(1030)、自定义区域 | 100005 PIR人体侦测:检测到前方人体移动触发告警 |
    | 1004 | 声音检测 | 300037 | 环境分贝异常或尖锐声响检测 | 间隔时间(s)、灵敏度(低/中/高)、声音报警(1009:循环次数/音频)、设备报警灯(1030:时长) | 100400 声音检测:环境分贝异常或尖锐声响检测 |
    | 1016 | 逗留提醒 | 300036 | 目标在特定区域内停留时间预警 | 无特殊配置 | 100021 逗留提醒:目标在特定区域内停留时间超过阈值 |
    | 1018 | 人物(人脸)识别 | 300033 | 智能识别特定人物 | 无特殊配置 | 100002 人脸识别:识别画面中特定人脸特征 |
    | 1021 | 低电检测 | 300028 | 电池电量不足时主动预警 | 无特殊配置 | 101201 低电检测:电池电量不足时主动预警 |
    | 1024 | 跌倒检测 | 300020 | 检测到突发性的摔倒动作 | 无特殊配置 | 102400 跌倒检测:检测到突发性的摔倒动作 |
    | 1025 | 火焰检测 | 300022 | 针对明火的快速识别报警 | 间隔时间(s)、灵敏度(低/中/高)、声音报警(1009)、设备报警灯(1030) | 102500 火焰检测:针对明火的快速识别报警 |
    | 1028 | 哭声检测 | 300023 | 灵敏识别婴儿哭泣或呼救声 | 间隔时间(s)、灵敏度(低/中/高)、声音报警(1009)、设备报警灯(1030) | 102800 哭声检测:灵敏识别婴儿哭泣或呼救声 |
    | 1029 | 宠物检测 | 300024 | 精确识别猫、狗等宠物活动 | 间隔时间(s)、灵敏度(低/中/高)、声音报警(1009)、设备报警灯(1030) | 102900 宠物检测:精确识别猫、狗等宠物活动 |
    | 1037 | 呼叫服务 | 300029 | 支持语音及视频呼叫功能 | 无特殊配置 | 103700 一键语音呼叫; 103701 视频+语音呼叫; 103702 挂断呼叫 |
    | 1070 | 离岗侦测 | 300043 | 监测工作人员离开固定职守岗位 | 间隔时间(s)、灵敏度(低/中/高)、声音报警(1009)、设备报警灯(1030) | 107000 离岗侦测; 107001 双人在岗 |
    | 1079 | 区域闯入 | 300034 | 目标跨线进入警戒区 | 间隔时间(s)、灵敏度(低/中/高)、声音报警(1009)、设备报警灯(1030)、自定义区域配置 | 107900 区域闯入:目标跨线进入警戒区 |
    | 1080 | 区域离开 | 300035 | 目标跨线离开受控区 | 间隔时间(s)、灵敏度(低/中/高)、声音报警(1009)、设备报警灯(1030)、自定义区域配置 | 108000 区域离开:目标跨线离开受控区 |
    | 1082 | 烟火侦测 | 300038 | 实时监测烟雾和火苗风险 | 间隔时间(s)、灵敏度(低/中/高)、声音报警(1009)、设备报警灯(1030) | 108200 烟火检测:实时监测烟雾和火苗风险 |
    | 1083 | 车辆侦测 | 300017 | 识别进入画面的各类机动车辆 | 间隔时间(s)、灵敏度(低/中/高)、声音报警(1009)、设备报警灯(1030) | 108300 车辆检测:识别进入画面的各类机动车辆 |
    | 1086 | 非机动车检测 | 300047 | 识别画面中的脚踏车、人力车等 | 间隔时间(s)、灵敏度(低/中/高)、声音报警(1009)、设备报警灯(1030)、自定义区域 | 108600 非机动车; 108601 电动自行车; 108602 自行车 |
    | 1088 | 车牌识别 | 300019 | 自动读取并识别车牌信息 | 无特殊配置 | 100020 车牌识别:自动读取并识别画面中的车牌信息 |
    | 1090 | 客流统计 | 300045 | 进入/出去行为识别与计数 | 无特殊配置 | 109000 进入:计数器增加的行为识别; 109001 出去:计数器减少的行为识别 |
    | 1093 | 离线监控 | 300008 | 设备断电或离线时的状态监测 | 无特殊配置 | 109300 设备离线:设备与云端断开连接; 109301 设备在线; 109302 设备休眠 |
    | 1098 | 智能告警服务 | 300009 | 基于多维参数的综合告警策略 | 无特殊配置 | 102900 宠物检测(智能报警); 108300 车辆检测(智能报警); 109600 儿童检测(智能报警); 109700 老人检测(智能报警); 109800 综合智能检测(智能报警); |
    | 1096 | 智能告警-儿童检测 | 300044 | 综合全天候的儿童看护识别 | 无特殊配置 | 109601 儿童哭闹; 109602 儿童出门; 109603 儿童进门; 109604 儿童摔跤; 109605 写作业检测; 109606 玩手机识别 |
    | 1103 | 智能告警-老人看护 | 300039 | 针对老年用户的异常行为识别 | 无特殊配置 | 110300 智能老人事件; 109701 老人外出; 109702 老人回家; 109703 老人摔倒 |
    | 1104 | 智能告警-厨房监测 | 300040 | 全方位监测厨房油烟和火情 | 无特殊配置 | 110400 智能厨房检测; 102500 火焰检测; 102600 厨房明火 |
    | 1105 | 智能告警-家门检测 | 300041 | 门口逗留、门缝检测等安防预警 | 无特殊配置 | 110500 智能家门检测; 108901 车位被占; 100017 不明人员闯入; 110900 包裹识别 |
    | 1106 | 智能告警-宠物检测 | 300042 | 整合宠物的多项健康和活动指标 | 无特殊配置 | 110600 智能宠物检测; 102901 宠物逗留; 102902 宠物拆家; 102903 宠物喝水; 102904 宠物进食; 102905 宠物睡觉; 102906 宠物排便 |
    | 1108 | GPS信息处理 | 300050 | 设备地理位置定位与上报 | 上报间隔(秒) | 无前端订阅可见事件(系统后台服务) |
    | 1109 | 包裹侦测 | 300025 | 检测门口或指定区域堆放的包裹 | 间隔时间(s)、灵敏度(低/中/高)、声音报警(1009)、设备报警灯(1030)、自定义区域 | 110900 包裹识别:检测门口或指定区域堆放的包裹 |
    | 1111 | 鱼类检测 | 300046 | 针对水族箱场景的特定识别 | 精彩瞬间开关、水温检测、水质检测、灵敏度(低/中/高)、鱼类种类(未知/热水鱼/冷水鱼)、最低温度、最高温度、App展示(℃/℉)、自定义区域配置 | 111100 检测鱼类:针对水族箱场景的特定识别; 111101 鱼类精彩瞬间:捕捉观赏鱼灵动状态 |
    | 1112 | 人脸检测 | 300018 | 检测画面中出现的人脸 | 人脸抓拍模式(质量/快速)、置信度(1-100)、灵敏度(低/中/高)、自定义区域配置 | 100015 人脸检测:检测画面中出现的人脸 |
    | 1114 | 宠物喂食 | 300049 | 监测宠物进食与自动喂食器联动 | 宠物喂食速度(1-10)、食物总量(0-100) | 无前端订阅可见事件(设备执行服务) |
    ========================================================================================================================================
    */

    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const isEcosystem = location.state?.source === 'ecosystem';
    const vendorName = location.state?.vendorName || '';
    const vendorProductName = location.state?.vendorProductName || decodeURIComponent(searchParams.get('vendorProductName') || '');
    const vendorProductId = location.state?.vendorProductId || searchParams.get('vendorProductId') || '';

    // 从固件详情页面打开时的参数
    const fromFirmware = searchParams.get('fwName');
    const productId = searchParams.get('productId') || '';
    const productName = decodeURIComponent(searchParams.get('productName') || '');
    const fwName = decodeURIComponent(searchParams.get('fwName') || '');
    const fwType = decodeURIComponent(searchParams.get('fwType') || '');
    const activeTabFromUrl = searchParams.get('tab') || 'device';
    const [currentStep, setCurrentStep] = useState(0);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [activeTab, setActiveTab] = useState(activeTabFromUrl);
    const [activeSideTab, setActiveSideTab] = useState('infra');
    const [activeInteractTab, setActiveInteractTab] = useState('voice'); // eslint-disable-line no-unused-vars
    const [eventDrawerVisible, setEventDrawerVisible] = useState(false);
    const [algoConfigDrawerVisible, setAlgoConfigDrawerVisible] = useState(false);
    const [currentAlgo, setCurrentAlgo] = useState(null);
    const [activeEventTab, setActiveEventTab] = useState('platform');

    // AI Link Form States
    const [aiLinkConfig, setAiLinkConfig] = useState({
        algorithms: {
            face: { supported: false },
            track_ability: { supported: false },
            track: { supported: false },
            motion: { supported: false },
            coord: { supported: false },
        },
        ai_face: { recogType: '0' },
        ai_stay: { enabled: false },
        ai_flow: { enabled: false },
        hardware: { infraSupported: false, infraMode: 'auto' },
        oneKeyCall: { supported: '0' },
        gestureCall: { supported: '0' },
        gps: { autoReport: '0' },
        sound_detect: { 
            supported: '0', 
            defaultOpen: '0', 
            sensitivity: '50',
            buzzerEnabled: '0',
            alarmLightEnabled: '0'
        },
        cry_detect: { 
            supported: '0', 
            defaultOpen: '0', 
            sensitivity: '50',
            buzzerEnabled: '0',
            alarmLightEnabled: '0'
        },
        pet_detect: { 
            supported: '0', 
            defaultOpen: '0', 
            sensitivity: '50',
            buzzerEnabled: '0',
            alarmLightEnabled: '0'
        },
        offpost_detect: { 
            supported: '0', 
            defaultOpen: '0', 
            sensitivity: '50',
            buzzerEnabled: '0',
            alarmLightEnabled: '0'
        },
        flame_detect: { 
            supported: '0', 
            defaultOpen: '0', 
            sensitivity: '50',
            buzzerEnabled: '0',
            alarmLightEnabled: '0'
        },
        smoke_detect: { 
            supported: '0', 
            defaultOpen: '0', 
            sensitivity: '50',
            buzzerEnabled: '0',
            alarmLightEnabled: '0'
        },
        intrude_detect: { 
            supported: '0', 
            defaultOpen: '0', 
            sensitivity: '50',
            buzzerEnabled: '0',
            alarmLightEnabled: '0',
            customAreaEnabled: false,
            regions: []
        },
        leave_detect: { 
            supported: '0', 
            defaultOpen: '0', 
            sensitivity: '50',
            buzzerEnabled: '0',
            alarmLightEnabled: '0',
            customAreaEnabled: false,
            regions: []
        },
        flow_stat: {
            interval: 60,
            watermark: false,
            report: true,
            monitorRegions: [],
            doorLines: []
        },
        offline_monitor: {
            storageEnabled: false
        },
        fish_tank: {
            highlightStatus: '0',
            waterTemperatureStatus: '0',
            waterQualityStatus: '0',
            sensitive: 50,
            fishSpecies: '0',
            defFishSpecies: '0',
            minWaterTemperature: 20,
            maxWaterTemperature: 30,
            showUnit: '1',
            detectAreaStatus: '0',
            detectAreaList: [{ regionID: '1', points: [{ x: 0, y: 0 }] }]
        },
        face_detect: {
            captureMode: '1',
            confidence: '3',
            sensitive: '50',
            detectAreaStatus: '0',
            detectAreaList: [{ regionID: '1', points: [{ x: 0, y: 0 }] }]
        },
        pet_feeder: {
            feedSpeed: 5,
            foodTotal: 50
        },
        pir_detect: { 
            supported: '0', 
            defaultOpen: '0', 
            sensitivity: '1',
            smartTrack: '1',
            interval: '30',
            buzzerEnabled: '0',
            alarmLightEnabled: '0'
        }
    });

    const [createForm] = Form.useForm();

    const onClose = () => setDrawerVisible(false);
    const handleSave = () => {
        message.success('保存成功');
        setDrawerVisible(false);
    };

    const steps = [
        { title: '功能定义与配置' },
        { title: '设备算法服务' },
        { title: '平台服务' },
    ];

    const deviceSideTabs = [
        { key: 'net', label: '联网方式' },
        { key: 'intercom', label: '对讲设置' },
        { key: 'storage', label: '存储设置' },
        { key: 'battery', label: '电池设置' },
        { key: 'workmode', label: '工作模式' },
        { key: 'wakeup', label: '唤醒能力' },
        { key: 'ota', label: 'OTA能力' },
        { key: 'light', label: '指示灯' },
        { key: 'infra', label: '红外灯' },
        { key: 'alarm', label: '报警录制' },
    ];

    const lensSideTabs = [
        { key: 'multi-lens', label: '多目配置' },
        { key: 'ptz', label: 'PTZ控制' },
        { key: 'stream', label: '视频码流' },
        { key: 'image', label: '图像参数' },
        { key: 'privacy', label: '隐私区域' },
        { key: 'watermark', label: '水印' },
        { key: 'fisheye', label: '鱼眼矫正' },
        { key: 'advanced', label: '高级配置项' },
    ];

    const micSideTabs = [
        { key: 'mic-param', label: '麦克风参数配置' },
        { key: 'audio-stream', label: '音频码流配置' },
    ];

    const displaySideTabs = [
        { key: 'resolution', label: '分辨率支持' },
        { key: 'screen-time', label: '屏幕时间' },
        { key: 'decode', label: '编码方式' },
        { key: 'display-type', label: '显示类型' },
    ];

    const speakerSideTabs = [
        { key: 'decode', label: '编码方式' },
        { key: 'volume', label: '音量调节' },
        { key: 'ringtone', label: '自定义铃声' },
        { key: 'bit-depth', label: '采样位深' },
        { key: 'sample-rate', label: '采样率' },
        { key: 'channel', label: '声道数' },
    ];

    const getSideTabs = (tab) => {
        const map = { device: deviceSideTabs, lens: lensSideTabs, mic: micSideTabs, display: displaySideTabs, speaker: speakerSideTabs };
        return map[tab] || [];
    };

    // ---- Mock Config States ----
    // 设备能力 - 对讲/存储/电池/工作模式/唤醒/OTA/指示灯/报警录制
    const [deviceConfig, setDeviceConfig] = useState({
        intercomMode: '0',      // 0=不支持, 1=半双工, 2=全双工
        storageMode: '0',       // 0=不支持, 1=TF卡, 2=磁盘
        storageFS: ['1'],       // fat32/exfat
        storageDisplay: '0',    // 0=显示容量, 1=显示剩余比例
        recordSound: '0',
        timerRecord: '1',       // 1=定时录制, 0=不录制
        timerStart: '00:00:00',
        timerEnd: '23:59:59',
        timerWeek: [1,2,4,8,16,32,64],
        hasBattery: '0',
        showPower: '0',
        switchWorkMode: '0',
        supportWorkModes: [],
        workMode: 1,
        workModeSwitch: '0',
        awakeAbility: '0',      // 0=不支持,1=本地,2=远程,3=本地+远程
        otaAbility: '1',
        hasIndicator: '1',
        indicatorOpen: true,
        alarmRecord: false,
        alarmDuration: 30,
        simSlots: 1,
        maxSubDevices: 4,
    });

    // 镜头配置
    const [lensConfig, setLensConfig] = useState({
        camWorkType: '0',       // 0=普通模式, 1=NVR模式
        camList: [],
        ptzSupported: '0',
        ptzPan: false, ptzTilt: false, ptzZoom: false,
        streams: [{ streamId: 0, resolutions: ['1280*720','1920*1080'], defaultRes: '1280*720', encTypes: ['H.264','H.265'], defaultEnc: 'H.265', smartEnc: false, frameRate: 25, bitRateType: 'CBR', bitRate: 2048 }],
        imageFlip: '0', imageMirror: '0',
        nightVision: '0',       // 0=智能,1=黑白,2=全彩,3=星光,4=红外
        privacyEnabled: false, privacyZones: [],
        watermarkEnabled: false, watermarkContent: 'Camera-001',
        fisheyeEnabled: false, fisheyeMode: '0',
        wdrEnabled: false, wdrLevel: 'auto',
        defogEnabled: false,
        corridorMode: '0',
    });

    // 麦克风配置
    const [micConfig, setMicConfig] = useState({
        micSupported: '1',
        micType: '0',           // 0=内置, 1=外置
        noiseReduction: true,
        agc: false,
        audioStreams: [{ streamId: 0, encTypes: ['AAC'], defaultEnc: 'AAC', sampleRate: '16000', bitRate: 64, channel: '1' }],
    });

    // 屏显配置
    const [displayConfig, setDisplayConfig] = useState({
        hasScreen: '1',
        resolutions: ['320*240','640*480','1280*720'],
        screenTime: 60,
        encTypes: ['H.264','MJPEG'],
        showTypes: ['时间戳','设备名称','自定义文字'],
    });

    // 喇叭配置
    const [speakerConfig, setSpeakerConfig] = useState({
        hornSupported: '1',
        encTypes: ['PCM','AAC'],
        setVolumeAbility: '1',
        volume: 75,
        ringToneAbility: '0',
        bitDepth: '16',
        sampleRate: '8000',
        channel: '1',
    });

    const abilityColumns = [
        { title: '类型', dataIndex: 'type', key: 'type', width: 100 },
        { title: '能力名称', dataIndex: 'name', key: 'name' },
        { title: '能力标识', dataIndex: 'id', key: 'id' },
        { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
        { title: '数据定义', dataIndex: 'definition', key: 'definition' },
        { title: '描述', dataIndex: 'desc', key: 'desc' },
        { title: '所属模块', dataIndex: 'module', key: 'module' },
        { 
            title: '操作', 
            key: 'action', 
            width: 120,
            render: () => (
                <Space>
                    <Button type="link" style={{ color: '#1890ff', padding: 0 }}>编辑</Button>
                    <Button type="link" style={{ color: '#ff4d4f', padding: 0 }}>删除</Button>
                </Space>
            ) 
        },
    ];

    const standardData = [
        { key: '1', type: '属性', name: '1234', id: '1234', dataType: 'Int(数字)', definition: '取值范围: 1 - 1', desc: '', module: '-' },
        { key: '2', type: '属性', name: '123', id: '123422', dataType: 'Int(数字)', definition: '取值范围: 123 - 2222', desc: '', module: '官方测试3' },
    ];

    const customData = [
        { key: '1', type: '属性', name: '客流人数统计开关', id: 'CalcSwitch', dataType: 'Boolean(布尔)', definition: <Tag>开启-1 关闭-0</Tag>, desc: '', module: '-' },
        { key: '2', type: '事件', name: '测试能力事件', id: 'TEST1226', dataType: '-', definition: '-', desc: '', module: '-' },
    ];

    const eventPlatformData = [
        { key: '1', id: 1, name: "人脸识别", eventId: "100002", desc: "识别画面中特定人脸特征" },
        { key: '2', id: 2, name: "区域闯入提示", eventId: "100010", desc: "侦测到目标进入设定的警戒区域" },
        { key: '3', id: 3, name: "区域离开提示", eventId: "100011", desc: "侦测到目标离开设定的警戒区域" },
        { key: '4', id: 4, name: "人脸检测", eventId: "100015", desc: "检测画面中出现的人脸" },
        { key: '5', id: 5, name: "逗留提醒", eventId: "100021", desc: "目标在特定区域内停留时间超过阈值" },
        { key: '8', id: 8, name: "鸟类识别", eventId: "200002", desc: "智能识别画面中的鸟类" },
        { key: '9', id: 9, name: "松鼠检测", eventId: "200003", desc: "捕捉松鼠出现的瞬间" },
        { key: '11', id: 11, name: "鸟类检测-报警", eventId: "200001", desc: "鸟类出现时触发实时报警" },
        { key: '12', id: 12, name: "移动检测", eventId: "100000", desc: "监测画面中像素发生位移变化" },
        { key: '13', id: 13, name: "人形识别", eventId: "100001", desc: "智能过滤非人物体，精确识别人物" },
        { key: '14', id: 14, name: "定时提醒", eventId: "300001", desc: "按照设定时间触发通知" },
        // { key: '15', id: 15, name: "Alexa(语音助手)", eventId: "300005", desc: "Amazon Alexa 语音服务控制" },
        // { key: '16', id: 16, name: "Google Home(语音助手)", eventId: "300006", desc: "Google Home 语音助理联动" },
        // { key: '17', id: 17, name: "移动侦测", eventId: "100000", desc: "发现移动物体时记录关键帧" },
        // { key: '18', id: 18, name: "人形侦测", eventId: "100001", desc: "检测到人形目标时触发告警图" },
        { key: '19', id: 19, name: "时光相册", eventId: "300007", desc: "生成精彩瞬间的时间轴视图" },
        { key: '20', id: 20, name: "离线监控", eventId: "300008", desc: "设备断电或离线时的状态监测" },
        { key: '21', id: 21, name: "声音检测", eventId: "100400", desc: "环境分贝异常或尖锐声响检测" },
        { key: '22', id: 22, name: "宠物检测(智能报警)", eventId: "102900", desc: "精确识别猫、狗等宠物活动" },
        { key: '23', id: 23, name: "车辆检测(智能报警)", eventId: "108300", desc: "识别进入画面的各类机动车辆" },
        { key: '24', id: 24, name: "烟火检测", eventId: "108200", desc: "实时监测烟雾和火苗风险" },
        { key: '26', id: 26, name: "儿童检测(智能报警)", eventId: "109600", desc: "专门针对儿童行为的智能识别" },
        { key: '27', id: 27, name: "老人检测(智能报警)", eventId: "109700", desc: "实时看护老人的日常动态" },
        { key: '27_1', id: 271, name: "智能检测事件", eventId: "109800", desc: "综合多种智能检测结果的告警事件" },
        { key: '28', id: 28, name: "车牌识别", eventId: "100020", desc: "自动读取并识别画面中的车牌信息" },
        { key: '29', id: 29, name: "跌倒检测", eventId: "102400", desc: "检测到突发性的摔倒动作" },
        { key: '30', id: 30, name: "火焰检测", eventId: "102500", desc: "针对明火的快速识别报警" },
        { key: '31', id: 31, name: "哭声检测", eventId: "102800", desc: "灵敏识别婴儿哭泣或呼救声" },
        { key: '32', id: 32, name: "包裹识别", eventId: "110900", desc: "检测门口或指定区域堆放的包裹" },
        { key: '33', id: 33, name: "定时抓拍设置", eventId: "300000", desc: "系统按固定周期执行全景抓拍" },
        { key: '34', id: 34, name: "手势抓拍", eventId: "300002", desc: "识别特定手势控制相机拍照" },
        { key: '35', id: 35, name: "手势呼叫", eventId: "300003", desc: "通过手势发起对讲或呼叫" },
        { key: '36', id: 36, name: "低电检测", eventId: "101201", desc: "电池电量不足时主动预警" },
        // { key: '37', id: 37, name: "告警策略", eventId: "100000", desc: "根据多维度参数综合判断告警等级" },
        { key: '38', id: 38, name: "一键语音呼叫", eventId: "103700", desc: "触发设备端实体按键发起呼叫" },
        { key: '39', id: 39, name: "视频+语音呼叫", eventId: "103701", desc: "同时发起双向视频和音频连接" },
        { key: '40', id: 40, name: "挂断呼叫", eventId: "103702", desc: "远程或物理结束当前的通话状态" },
        { key: '41', id: 41, name: "离岗侦测", eventId: "107000", desc: "监测工作人员离开固定职守岗位" },
        { key: '42', id: 42, name: "老人外出", eventId: "109701", desc: "老人离开安全看护区域" },
        { key: '43', id: 43, name: "老人回家", eventId: "109702", desc: "老人安全返回看护区域" },
        { key: '44', id: 44, name: "老人摔倒", eventId: "109703", desc: "老年用户突发摔倒后的高阶报警" },
        { key: '45', id: 45, name: "厨房明火", eventId: "102600", desc: "监测厨房环境下的火焰异常" },
        { key: '46', id: 46, name: "车位被占", eventId: "108901", desc: "识别非预留车辆进入私人车位" },
        { key: '47', id: 47, name: "不明人员闯入", eventId: "100017", desc: "识别不在数据库中的陌生访客" },
        { key: '49', id: 49, name: "宠物逗留", eventId: "102901", desc: "宠物长时间停留在禁入区" },
        { key: '50', id: 50, name: "双人在岗", eventId: "107001", desc: "符合双人作业规范的职守监测" },
        { key: '51', id: 51, name: "家门监测", eventId: "200006", desc: "专注家门口安全的开关门动态监测" },
        { key: '52', id: 52, name: "宠物拆家", eventId: "102902", desc: "识别宠物破坏家具等剧烈动作" },
        { key: '53', id: 53, name: "儿童哭闹", eventId: "109601", desc: "监测幼儿情绪异常及大声哭泣" },
        { key: '54', id: 54, name: "儿童出门", eventId: "109602", desc: "防止小孩擅自离开家门" },
        { key: '55', id: 55, name: "儿童进门", eventId: "109603", desc: "推送小孩学放学回家消息" },
        { key: '56', id: 56, name: "儿童摔跤", eventId: "109604", desc: "实时看护小孩在室内的安全状态" },
        { key: '57', id: 57, name: "写作业检测", eventId: "109605", desc: "智能监测小孩学习状态" },
        { key: '58', id: 58, name: "玩手机识别", eventId: "109606", desc: "识别小孩在学习时间使用电子设备" },
        { key: '59', id: 59, name: "宠物喝水", eventId: "102903", desc: "监测宠物饮水频率和习惯" },
        { key: '60', id: 60, name: "宠物进食", eventId: "102904", desc: "监测宠物采食行为" },
        { key: '61', id: 61, name: "宠物睡觉", eventId: "102905", desc: "记录宠物的休息时长和质量" },
        { key: '62', id: 62, name: "宠物排便", eventId: "102906", desc: "通过卫生间监控了解宠物健康" },
        { key: '63', id: 63, name: "区域闯入", eventId: "107900", desc: "目标跨线进入警戒区" },
        { key: '64', id: 64, name: "区域离开", eventId: "108000", desc: "目标跨线离开受控区" },
        { key: '65', id: 65, name: "进入", eventId: "109000", desc: "计数器增加的行为识别" },
        { key: '66', id: 66, name: "出去", eventId: "109001", desc: "计数器减少的行为识别" },
        { key: '67', id: 67, name: "检测鱼类", eventId: "111100", desc: "针对水族箱场景的特定识别" },
        { key: '68', id: 68, name: "鱼类精彩瞬间", eventId: "111101", desc: "捕捉观赏鱼灵动状态" },
        { key: '69', id: 69, name: "非机动车", eventId: "108600", desc: "识别画面中的脚踏车、人力车等" },
        { key: '70', id: 70, name: "电动自行车", eventId: "108601", desc: "精确识别电动两轮/三轮车" },
        { key: '71', id: 71, name: "自行车", eventId: "108602", desc: "单车入室或违停监测" },
        { key: '72', id: 72, name: "智能老人事件", eventId: "110300", desc: "综合判断老年用户的异常生活习惯" },
        { key: '73', id: 73, name: "智能厨房检测", eventId: "110400", desc: "全方位监测厨房油烟和火情" },
        { key: '74', id: 74, name: "智能家门检测", eventId: "110500", desc: "门口逗留、门缝检测等综合安防" },
        { key: '75', id: 75, name: "智能宠物检测", eventId: "110600", desc: "整合宠物的多项健康和活动指标" },
        { key: '76', id: 76, name: "儿童哭闹", eventId: "106901", desc: "更细粒度的幼儿悲伤情绪捕捉" },
        { key: '77', id: 77, name: "儿童外出", eventId: "106902", desc: "结合门锁状态判断的小孩离家" },
        { key: '78', id: 78, name: "儿童回家", eventId: "106903", desc: "安全归来的确认通知" },
        { key: '79', id: 79, name: "儿童摔倒", eventId: "106904", desc: "高频采样识别的突发摔离伤风险" },
        { key: '80', id: 80, name: "做作业", eventId: "106905", desc: "专注学习时的平稳状态监测" },
        { key: '81', id: 81, name: "玩手机", eventId: "106906", desc: "特定的娱乐时间违规识别" },
        { key: '82', id: 82, name: "智能儿童检测", eventId: "106900", desc: "综合全天候的儿童看护总结事件" },
        { key: '83', id: 83, name: "设备离线", eventId: "109300", desc: "设备与云端断开连接" },
        { key: '84', id: 84, name: "设备在线", eventId: "109301", desc: "设备成功连接到云端" },
        { key: '85', id: 85, name: "设备休眠", eventId: "109302", desc: "设备进入低功耗待机状态" }
    ];

    const eventColumns = [
        { title: '事件ID', dataIndex: 'eventId', key: 'eventId', width: 120 },
        { title: '事件名称', dataIndex: 'name', key: 'name', width: 150 },
        { title: '事件描述', dataIndex: 'desc', key: 'desc' },
    ];

    const [algorithmData, setAlgorithmData] = useState([
        { key: 'cloud_event', id: '1010', service_id:'300010', name: '事件云存', desc: '用于存储录制事件', supported: false, freeOpen: true },
        { key: 'cloud_allday', id: '1010', service_id:'300011', name: '全天云存', desc: '用于存储视频回看', supported: false, freeOpen: false },
        { key: '26a', id: '1000', _mergeFirst: true, service_id: '300026', service_name: '人形检测服务', service_desc: '基于AI的人形识别服务', name: '人形检测', desc: '智能过滤非人物体，精确识别人物', supported: false, freeOpen: true },
        { key: '26b', id: '1000', service_id: '300027', service_name: '运动检测服务', service_desc: '监测画面像素变化', name: '运动检测', desc: '监测画面中像素发生位移变化', supported: false, freeOpen: true },
        { key: 'cloud_capture', id: '1011', service_id: '3000XX', service_name: '云端抓图服务', service_desc: '设备端云端抓图能力配置', name: '云端抓图', desc: '设备端云端抓图配置', supported: false, freeOpen: false },
        { key: '36', id: '1003', service_id:'300048',name: 'PIR红外检测', desc: '基于红外热释电的人体活动监测', supported: false, freeOpen: false },
        { key: '33', id: '1004', service_id:'300037',name: '声音检测', desc: '环境分贝异常或尖锐声响检测', supported: false, freeOpen: false },
        { key: '32', id: '1016', service_id:'300036',name: '逗留提醒', desc: '目标在特定区域内停留时间预警', supported: false, freeOpen: false },
        { key: '31', id: '1018', service_id:'300033',name: '人物(人脸)识别', desc: '智能识别特定人物', supported: false, freeOpen: false },
        { key: '27', id: '1021', service_id:'300028',name: '低电检测', desc: '电池电量不足时主动预警', supported: false, freeOpen: true },
        { key: '22', id: '1024', service_id:'300020',name: '跌倒检测', desc: '检测到突发性的摔倒动作', supported: false, freeOpen: false },
        { key: '23', id: '1025', service_id:'300022',name: '火焰检测', desc: '针对明火的快速识别报警', supported: false, freeOpen: false },
        { key: '24', id: '1028', service_id:'300023',name: '哭声检测', desc: '灵敏识别婴儿哭泣或呼救声', supported: false, freeOpen: false },
        { key: '25', id: '1029', service_id:'300024',name: '宠物检测', desc: '精确识别猫、狗等宠物活动', supported: false, freeOpen: false },
        { key: '28', id: '1037', service_id:'300029',name: '呼叫服务', desc: '支持语音及视频呼叫功能', supported: false, freeOpen: true },
        { key: '1', id: '1070', service_id:'300043',name: '离岗侦测', desc: '监测工作人员离开固定职守岗位', supported: false, freeOpen: false },
        { key: '2', id: '1079', service_id:'300034',name: '区域闯入', desc: '目标跨线进入警戒区', supported: true, freeOpen: false },
        { key: '3', id: '1080', service_id:'300035',name: '区域离开', desc: '目标跨线离开受控区', supported: true, freeOpen: false },
        { key: '4', id: '1082', service_id:'300038',name: '烟火侦测', desc: '实时监测烟雾和火苗风险', supported: false, freeOpen: false },
        { key: '5', id: '1083', service_id:'300017',name: '车辆侦测', desc: '识别进入画面的各类机动车辆', supported: false, freeOpen: false },
        { key: '6', id: '1086', service_id:'300047',name: '非机动车检测', desc: '识别画面中的脚踏车、人力车等', supported: false, freeOpen: false },
        { key: '21', id: '1088', service_id:'300019',name: '车牌识别', desc: '自动读取并识别车牌信息', supported: false, freeOpen: false },
        { key: '7', id: '1090', service_id:'300045',name: '客流统计', desc: '进入/出去行为识别与计数', supported: false, freeOpen: false },
        { key: '8', id: '1093', service_id:'300008',name: '离线监控', desc: '设备断电或离线时的状态监测', supported: true, freeOpen: true },
        { key: '37', id: '1098', service_id:'300009',name: '智能告警服务', desc: '基于多维参数的综合告警策略', supported: false, freeOpen: false },
        { key: '35', id: '1096', service_id:'300044',name: '智能告警-儿童检测', desc: '综合全天候的儿童看护识别', supported: false, freeOpen: false },
        { key: '10', id: '1103', service_id:'300039',name: '智能告警-老人看护', desc: '针对老年用户的异常行为识别', supported: false, freeOpen: false },
        { key: '34', id: '1104', service_id:'300040',name: '智能告警-厨房监测', desc: '全方位监测厨房油烟和火情', supported: false, freeOpen: false },
        { key: '11', id: '1105', service_id:'300041',name: '智能告警-家门检测', desc: '门口逗留、门缝检测等安防预警', supported: false, freeOpen: false },
        { key: '12', id: '1106', service_id:'300042',name: '智能告警-宠物检测', desc: '整合宠物的多项健康和活动指标', supported: false, freeOpen: false },
        { key: '37b', id: '1108', service_id:'300050',name: 'GPS信息处理', desc: '设备地理位置定位与上报', supported: false, freeOpen: true },
        { key: '13', id: '1109', service_id:'300025',name: '包裹侦测', desc: '检测门口或指定区域堆放的包裹', supported: false, freeOpen: false },
        { key: '15', id: '1111', service_id:'300046',name: '鱼类检测', desc: '针对水族箱场景的特定识别', supported: false, freeOpen: false },
        { key: '16', id: '1112', service_id:'300018',name: '人脸检测', desc: '检测画面中出现的人脸', supported: true, freeOpen: false },
        { key: '17', id: '1114', service_id:'300049',name: '宠物喂食', desc: '监测宠物进食与自动喂食器联动', supported: false, freeOpen: false },
    ]);

    const appPathColumns = [ // eslint-disable-line no-unused-vars
        { 
            title: <Checkbox />, 
            dataIndex: 'checked', 
            key: 'checked', 
            width: 50,
            render: () => <Checkbox />
        },
        { title: '功能名称', dataIndex: 'name', key: 'name' },
        { title: '归属模块', dataIndex: 'module', key: 'module' },
        { title: '描述', dataIndex: 'desc', key: 'desc' },
        { title: '路径', dataIndex: 'path', key: 'path' },
        { 
            title: '操作', 
            key: 'action', 
            width: 100,
            render: () => <Button type="link" style={{ color: '#1890ff', padding: 0 }}>添加路径</Button>
        },
    ];

    const appPathData = [ // eslint-disable-line no-unused-vars
        { key: '1', name: '1234', module: '设备能力', desc: '', path: '' },
        { key: '2', name: '123', module: '设备能力', desc: '', path: '' },
        { key: '3', name: '客流人数统计开关', module: '设备能力', desc: '', path: '' },
        { key: '4', name: '测试能力事件', module: '设备能力', desc: '', path: '' },
    ];

    const voiceColumns = [
        { title: 'AlloTType', dataIndex: 'alloTType', key: 'alloTType', width: 100 },
        { title: '语音助手', dataIndex: 'platform', key: 'platform' },
        { title: '功能描述', dataIndex: 'desc', key: 'desc' },
        { 
            title: '是否支持', 
            dataIndex: 'status', 
            key: 'status', 
            render: (status) => <Switch size="small" defaultChecked={status === '已开通'} /> 
        },
    ];

    const voiceData = [
        { key: '1', alloTType: '1063', platform: 'Alexa', status: '未开通', desc: '支持 Alexa 语音查询和控制', effectMode: '出厂内置' },
        { key: '2', alloTType: '1063', platform: 'Google Home', status: '已开通', desc: '支持 Google Home 语音控制', effectMode: '需用户购买' },
    ];

    const pushColumns = [ // eslint-disable-line no-unused-vars
        { title: '推送类型', dataIndex: 'type', key: 'type' },
        { title: '推送内容', dataIndex: 'content', key: 'content' },
        { title: '是否开启', dataIndex: 'enabled', key: 'enabled', render: (val) => <Switch size="small" defaultChecked={val} /> },
    ];

    const pushData = [ // eslint-disable-line no-unused-vars
        { key: '1', type: '报警消息', content: '设备侦测到移动目标', enabled: true },
        { key: '2', type: '系统消息', content: '设备上线/下线通知', enabled: true },
    ];

    return (
        <div className="product-detail-container">
            {!hideHeader && <Card bordered={false} className="header-card">
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <Button
                        type="link"
                        icon={<ArrowLeftOutlined />}
                        onClick={() => navigate(-1)}
                        style={{ paddingLeft: 0, color: '#333' }}
                    >
                        返回
                    </Button>
                    <Divider type="vertical" style={{ height: 20, margin: '5px 12px' }} />
                    <div style={{ flex: 1 }}>
                        {fromFirmware ? (
                            <>
                                <Title level={4} style={{ margin: '0 0 12px 0' }}>配置物模型</Title>
                                <div style={{ padding: 16 }}>
                                    <Row gutter={[24, 12]}>
                                        <Col span={6}>
                                            <div><Text type="secondary" style={{ fontSize: 12 }}>固件信息</Text></div>
                                            <div style={{ fontWeight: 500, marginTop: 4 }}>{fwName}</div>
                                        </Col>
                                        <Col span={9}>
                                            <div><Text type="secondary" style={{ fontSize: 12 }}>所属产品</Text></div>
                                            <div style={{ fontWeight: 500, marginTop: 4 }}>{productName} <Text type="secondary">{productId}</Text></div>
                                        </Col>
                                        <Col span={6}>
                                            <div><Text type="secondary" style={{ fontSize: 12 }}>固件类型</Text></div>
                                            <div style={{ fontWeight: 500, marginTop: 4 }}><Tag color={fwType === '生产固件' ? 'blue' : 'orange'}>{fwType}</Tag></div>
                                        </Col>
                                        <Col span={3}>
                                            <div><Text type="secondary" style={{ fontSize: 12 }}>固件说明</Text></div>
                                            <div style={{ fontWeight: 500, marginTop: 4 }}>—</div>
                                        </Col>
                                    </Row>
                                </div>
                            </>
                        ) : (
                            <>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <Title level={4} style={{ margin: 0 }}>{isEcosystem ? '整机产品详情' : '开发产品'}</Title>
                                    {isEcosystem && <Tag color="blue">方案派生</Tag>}
                                </div>
                                {isEcosystem && (
                                    <div style={{ marginTop: 4 }}>
                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                            方案商：{vendorName || '-'} ｜ 方案产品：{vendorProductName || '-'}（{vendorProductId || '-'}）
                                        </Text>
                                    </div>
                                )}
                                <div style={{ marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div>
                                        <Text strong style={{ fontSize: '16px' }}>前端测试复制产品</Text>
                                        {!isEcosystem && <Button type="link" icon={<EditOutlined />} size="small">编辑产品</Button>}
                                    </div>
                                    {!isEcosystem && <Button type="primary" onClick={() => message.success('保存配置成功')}>保存配置</Button>}
                                </div>
                                <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: 8 }}>
                                    产品ID: PV3Pa2DJTKmq6uBT | 产品型号: 123123 | 产品类目: 摄像机 | 联网方式: -
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Card>}

            <Card className="steps-card" bordered={false}>
                <Steps 
                    current={currentStep} 
                    onChange={setCurrentStep}
                    items={steps} 
                    labelPlacement="horizontal" 
                    style={{ cursor: 'pointer' }}
                />
            </Card>

            <Card className="content-card" bordered={false} bodyStyle={{ padding: 0 }}>
                {currentStep === 0 && (
                    <div style={{ padding: '0 24px 24px' }}>
                        <Tabs 
                            activeKey={activeTab}
                            onChange={(key) => {
                                setActiveTab(key);
                                const tabs = getSideTabs(key);
                                if (tabs.length > 0) setActiveSideTab(tabs[0].key);
                            }}
                            items={[
                                { label: '设备能力', key: 'device' },
                                { label: '镜头配置', key: 'lens' },
                                { label: '麦克风配置', key: 'mic' },
                                { label: '屏显配置', key: 'display' },
                                { label: '喇叭配置', key: 'speaker' }
                            ]}
                            className="detail-tabs"
                        />
                        
                        <div style={{ display: 'flex', border: '1px solid #f0f0f0', borderRadius: '4px', marginTop: 16 }}>
                            <div style={{ width: 120, borderRight: '1px solid #f0f0f0', backgroundColor: '#fafafa' }}>
                                <div style={{ padding: '12px', fontSize: '12px', color: '#8c8c8c', display: 'flex', alignItems: 'center' }}>
                                    <EditOutlined style={{ marginRight: 4 }} /> 配置选项
                                </div>
                                {getSideTabs(activeTab).map(tab => (
                                    <div 
                                        key={tab.key} 
                                        onClick={() => setActiveSideTab(tab.key)}
                                        style={{ 
                                            padding: '12px 16px', 
                                            cursor: 'pointer',
                                            backgroundColor: activeSideTab === tab.key ? '#1890ff' : 'transparent',
                                            color: activeSideTab === tab.key ? '#fff' : 'rgba(0,0,0,0.65)',
                                            fontSize: '13px'
                                        }}
                                    >
                                        {tab.label}
                                    </div>
                                ))}
                            </div>
                            <div style={{ flex: 1, padding: '24px 40px' }}>
                                {/* ═══ 设备能力 ═══ */}
                                {activeTab === 'device' && activeSideTab === 'net' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }} labelAlign="left">
                                        <Form.Item label="联网方式">
                                            <Checkbox.Group defaultValue={['WIFI']}>
                                                <Space size={24}>
                                                    <Checkbox value="wired">有线</Checkbox>
                                                    <Checkbox value="WIFI">WIFI</Checkbox>
                                                    <Checkbox value="mobile">移动网络</Checkbox>
                                                </Space>
                                            </Checkbox.Group>
                                        </Form.Item>
                                        <Form.Item label="是否支持双频路由器">
                                            <Radio.Group defaultValue="yes">
                                                <Radio value="no">否</Radio>
                                                <Radio value="yes">是</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="配网方式">
                                            <Space wrap size={[24, 12]}>
                                                <Checkbox>AP</Checkbox>
                                                <Checkbox>声音</Checkbox>
                                                <Checkbox>smartlink</Checkbox>
                                                <Checkbox>摄像机识别二维码添加</Checkbox>
                                                <Checkbox>局域网</Checkbox>
                                                <Checkbox>APP扫码添加</Checkbox>
                                                <Checkbox>蓝牙添加</Checkbox>
                                            </Space>
                                        </Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'device' && activeSideTab === 'intercom' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>对讲设置</Divider>
                                        <Form.Item label="支持对讲方式">
                                            <Radio.Group value={deviceConfig.intercomMode} onChange={e => setDeviceConfig(p => ({...p, intercomMode: e.target.value}))}>
                                                <Radio value="0">不支持对讲</Radio>
                                                <Radio value="1">半双工</Radio>
                                                <Radio value="2">全双工</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'device' && activeSideTab === 'storage' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>存储设置</Divider>
                                        <Form.Item label="存储方式">
                                            <Radio.Group value={deviceConfig.storageMode} onChange={e => setDeviceConfig(p => ({...p, storageMode: e.target.value}))}>
                                                <Radio value="0">不支持</Radio>
                                                <Radio value="1">TF卡存储</Radio>
                                                <Radio value="2">磁盘存储</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        {deviceConfig.storageMode !== '0' && (<>
                                        <Form.Item label="文件系统">
                                            <Checkbox.Group value={deviceConfig.storageFS} onChange={v => setDeviceConfig(p => ({...p, storageFS: v}))}>
                                                <Checkbox value="1">fat32</Checkbox>
                                                <Checkbox value="0">exfat</Checkbox>
                                            </Checkbox.Group>
                                        </Form.Item>
                                        <Form.Item label="内存显示方式">
                                            <Radio.Group value={deviceConfig.storageDisplay} onChange={e => setDeviceConfig(p => ({...p, storageDisplay: e.target.value}))}>
                                                <Radio value="0">显示容量</Radio>
                                                <Radio value="1">显示剩余比例</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="是否录制声音">
                                            <Radio.Group value={deviceConfig.recordSound} onChange={e => setDeviceConfig(p => ({...p, recordSound: e.target.value}))}>
                                                <Radio value="1">是</Radio>
                                                <Radio value="0">否</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        </>)}
                                        <Form.Item label="常规录制方式">
                                            <Radio.Group value={deviceConfig.timerRecord} onChange={e => setDeviceConfig(p => ({...p, timerRecord: e.target.value}))}>
                                                <Radio value="1">定时录制</Radio>
                                                <Radio value="0">不录制</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        {deviceConfig.timerRecord === '1' && (<>
                                        <Form.Item label="录制时段">
                                            <Space>
                                                <TimePicker defaultValue={dayjs('00:00:00', 'HH:mm:ss')} format="HH:mm:ss" />
                                                <Text>—</Text>
                                                <TimePicker defaultValue={dayjs('23:59:59', 'HH:mm:ss')} format="HH:mm:ss" />
                                            </Space>
                                        </Form.Item>
                                        <Form.Item label="重复">
                                            <Checkbox.Group defaultValue={['周一','周二','周三','周四','周五','周六','周日']}>
                                                <Space wrap><Checkbox value="周一">周一</Checkbox><Checkbox value="周二">周二</Checkbox><Checkbox value="周三">周三</Checkbox><Checkbox value="周四">周四</Checkbox><Checkbox value="周五">周五</Checkbox><Checkbox value="周六">周六</Checkbox><Checkbox value="周日">周日</Checkbox></Space>
                                            </Checkbox.Group>
                                        </Form.Item>
                                        </>)}
                                    </Form>
                                )}
                                {activeTab === 'device' && activeSideTab === 'battery' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>电池设置</Divider>
                                        <Form.Item label="是否有电池">
                                            <Radio.Group value={deviceConfig.hasBattery} onChange={e => setDeviceConfig(p => ({...p, hasBattery: e.target.value}))}>
                                                <Radio value="1">有</Radio>
                                                <Radio value="0">无</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        {deviceConfig.hasBattery === '1' && (
                                        <Form.Item label="充电状态显示电量">
                                            <Radio.Group value={deviceConfig.showPower} onChange={e => setDeviceConfig(p => ({...p, showPower: e.target.value}))}>
                                                <Radio value="1">支持</Radio>
                                                <Radio value="0">不支持</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        )}
                                    </Form>
                                )}
                                {activeTab === 'device' && activeSideTab === 'workmode' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>工作模式</Divider>
                                        <Form.Item label="是否支持切换工作模式">
                                            <Radio.Group value={deviceConfig.switchWorkMode} onChange={e => setDeviceConfig(p => ({...p, switchWorkMode: e.target.value}))}>
                                                <Radio value="1">支持</Radio>
                                                <Radio value="0">不支持</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        {deviceConfig.switchWorkMode === '1' && (<>
                                        <Form.Item label="支持的工作模式">
                                            <Checkbox.Group defaultValue={['常驻','低功耗']}>
                                                <Checkbox value="常驻">常驻</Checkbox>
                                                <Checkbox value="低功耗">低功耗</Checkbox>
                                                <Checkbox value="超低功耗">超低功耗</Checkbox>
                                                <Checkbox value="AOV">AOV</Checkbox>
                                            </Checkbox.Group>
                                        </Form.Item>
                                        <Form.Item label="默认工作模式">
                                            <Select defaultValue="常驻" style={{ width: 160 }}>
                                                <Option value="常驻">常驻</Option>
                                                <Option value="低功耗">低功耗</Option>
                                                <Option value="超低功耗">超低功耗</Option>
                                                <Option value="AOV">AOV</Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item label="默认切换方式">
                                            <Radio.Group value={deviceConfig.workModeSwitch} onChange={e => setDeviceConfig(p => ({...p, workModeSwitch: e.target.value}))}>
                                                <Radio value="0">按电量</Radio>
                                                <Radio value="1">指定模式</Radio>
                                                <Radio value="2">定时切换</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        </>)}
                                    </Form>
                                )}
                                {activeTab === 'device' && activeSideTab === 'wakeup' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>唤醒能力</Divider>
                                        <Form.Item label="是否支持唤醒">
                                            <Radio.Group value={deviceConfig.awakeAbility} onChange={e => setDeviceConfig(p => ({...p, awakeAbility: e.target.value}))}>
                                                <Radio value="0">不支持</Radio>
                                                <Radio value="1">本地唤醒</Radio>
                                                <Radio value="2">远程唤醒</Radio>
                                                <Radio value="3">本地和远程</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'device' && activeSideTab === 'ota' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>OTA能力</Divider>
                                        <Form.Item label="是否支持远程OTA">
                                            <Radio.Group value={deviceConfig.otaAbility} onChange={e => setDeviceConfig(p => ({...p, otaAbility: e.target.value}))}>
                                                <Radio value="1">支持</Radio>
                                                <Radio value="0">不支持</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'device' && activeSideTab === 'light' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>指示灯</Divider>
                                        <Form.Item label="是否有状态指示灯">
                                            <Radio.Group value={deviceConfig.hasIndicator} onChange={e => setDeviceConfig(p => ({...p, hasIndicator: e.target.value}))}>
                                                <Radio value="1">有</Radio>
                                                <Radio value="0">无</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        {deviceConfig.hasIndicator === '1' && (
                                        <Form.Item label="默认打开">
                                            <Switch checked={deviceConfig.indicatorOpen} onChange={v => setDeviceConfig(p => ({...p, indicatorOpen: v}))} />
                                        </Form.Item>
                                        )}
                                    </Form>
                                )}
                                {activeTab === 'device' && activeSideTab === 'infra' && (
                                    <div style={{ padding: '0 20px' }}>
                                        <Form layout="horizontal" labelCol={{ span: 5 }}>
                                            <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>红外灯配置</Divider>
                                            <Form.Item label="是否支持">
                                                <Radio.Group 
                                                    value={aiLinkConfig.hardware.infraSupported ? '1' : '0'} 
                                                    onChange={(e) => setAiLinkConfig({...aiLinkConfig, hardware: {...aiLinkConfig.hardware, infraSupported: e.target.value === '1'}})}>
                                                    <Radio value="1">是</Radio>
                                                    <Radio value="0">否</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                            {aiLinkConfig.hardware.infraSupported && (
                                                <div style={{ padding: '0 20px', borderLeft: '2px solid #f0f0f0', marginLeft: 16 }}>
                                                    <Form.Item label="红外切换模式">
                                                        <Radio.Group value={aiLinkConfig.hardware.infraMode} onChange={(e) => setAiLinkConfig({...aiLinkConfig, hardware: {...aiLinkConfig.hardware, infraMode: e.target.value}})}>
                                                            <Radio value="manual_auto">手动+自动</Radio>
                                                            <Radio value="auto">自动</Radio>
                                                            <Radio value="manual">手动</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </div>
                                            )}
                                        </Form>
                                    </div>
                                )}
                                {activeTab === 'device' && activeSideTab === 'alarm' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>报警录制</Divider>
                                        <Alert message="该报警配置仅针对卡录像生效" type="info" showIcon style={{ marginBottom: 16 }} />
                                        <Form.Item label="是否打开报警录制">
                                            <Switch checked={deviceConfig.alarmRecord} onChange={v => setDeviceConfig(p => ({...p, alarmRecord: v}))} />
                                        </Form.Item>
                                        {deviceConfig.alarmRecord && (
                                        <Form.Item label="默认报警录制时长（秒）">
                                            <InputNumber min={1} max={3600} value={deviceConfig.alarmDuration} onChange={v => setDeviceConfig(p => ({...p, alarmDuration: v}))} style={{ width: 200 }} />
                                        </Form.Item>
                                        )}
                                    </Form>
                                )}
                                {/* ═══ 镜头配置 ═══ */}
                                {activeTab === 'lens' && activeSideTab === 'multi-lens' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>多目配置</Divider>
                                        <Form.Item label="摄像机工作模式">
                                            <Radio.Group value={lensConfig.camWorkType} onChange={e => setLensConfig(p => ({...p, camWorkType: e.target.value}))}>
                                                <Radio value="0">普通模式</Radio>
                                                <Radio value="1">NVR模式</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="摄像头数量">
                                            <Select defaultValue="1" style={{ width: 120 }}>
                                                <Option value="1">1个</Option>
                                                <Option value="2">2个</Option>
                                                <Option value="3">3个</Option>
                                                <Option value="4">4个</Option>
                                            </Select>
                                        </Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'lens' && activeSideTab === 'ptz' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>PTZ控制</Divider>
                                        <Form.Item label="是否支持PTZ">
                                            <Radio.Group value={lensConfig.ptzSupported} onChange={e => setLensConfig(p => ({...p, ptzSupported: e.target.value}))}>
                                                <Radio value="1">支持</Radio>
                                                <Radio value="0">不支持</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        {lensConfig.ptzSupported === '1' && (
                                        <Form.Item label="支持方向">
                                            <Checkbox.Group defaultValue={['pan','tilt']}>
                                                <Checkbox value="pan">水平旋转</Checkbox>
                                                <Checkbox value="tilt">垂直旋转</Checkbox>
                                                <Checkbox value="zoom">变焦</Checkbox>
                                            </Checkbox.Group>
                                        </Form.Item>
                                        )}
                                    </Form>
                                )}
                                {activeTab === 'lens' && activeSideTab === 'stream' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>视频码流</Divider>
                                        <Form.Item label="支持分辨率">
                                            <Checkbox.Group defaultValue={['1280*720','1920*1080']}>
                                                <Space wrap>
                                                    <Checkbox value="640*360">640*360</Checkbox>
                                                    <Checkbox value="640*480">640*480</Checkbox>
                                                    <Checkbox value="1280*720">1280*720</Checkbox>
                                                    <Checkbox value="1920*1080">1920*1080</Checkbox>
                                                    <Checkbox value="2560*1440">2560*1440</Checkbox>
                                                </Space>
                                            </Checkbox.Group>
                                        </Form.Item>
                                        <Form.Item label="默认分辨率">
                                            <Select defaultValue="1280*720" style={{ width: 160 }} options={['640*360','640*480','1280*720','1920*1080','2560*1440'].map(v=>({value:v,label:v}))} />
                                        </Form.Item>
                                        <Form.Item label="支持编码方式">
                                            <Checkbox.Group defaultValue={['H.264','H.265']}>
                                                <Space><Checkbox value="MJPEG">MJPEG</Checkbox><Checkbox value="H.264">H.264</Checkbox><Checkbox value="H.265">H.265</Checkbox></Space>
                                            </Checkbox.Group>
                                        </Form.Item>
                                        <Form.Item label="默认编码方式">
                                            <Select defaultValue="H.265" style={{ width: 120 }}>
                                                <Option value="H.264">H.264</Option>
                                                <Option value="H.265">H.265</Option>
                                                <Option value="MJPEG">MJPEG</Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item label="智能编码开关"><Switch defaultChecked /></Form.Item>
                                        <Form.Item label="帧率(FPS)">
                                            <Select defaultValue="25" style={{ width: 100 }}>
                                                <Option value="15">15</Option><Option value="20">20</Option><Option value="25">25</Option><Option value="30">30</Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item label="码率类型">
                                            <Radio.Group defaultValue="CBR">
                                                <Radio value="CBR">CBR</Radio><Radio value="VBR">VBR</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="码率(kbps)"><InputNumber min={64} max={16384} defaultValue={2048} style={{ width: 160 }} /></Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'lens' && activeSideTab === 'image' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>图像参数</Divider>
                                        <Form.Item label="翻转">
                                            <Radio.Group value={lensConfig.imageFlip} onChange={e => setLensConfig(p => ({...p, imageFlip: e.target.value}))}>
                                                <Radio value="0">正常</Radio><Radio value="1">垂直翻转</Radio><Radio value="2">水平翻转</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="夜视能力">
                                            <Radio.Group value={lensConfig.nightVision} onChange={e => setLensConfig(p => ({...p, nightVision: e.target.value}))}>
                                                <Radio value="0">智能模式</Radio><Radio value="1">黑白模式</Radio><Radio value="2">全彩模式</Radio><Radio value="3">星光夜视</Radio><Radio value="4">红外模式</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="宽动态(WDR)">
                                            <Radio.Group defaultValue="auto">
                                                <Radio value="off">关闭</Radio><Radio value="auto">自动</Radio><Radio value="on">强制开启</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="走廊模式">
                                            <Radio.Group defaultValue="off"><Radio value="off">关闭</Radio><Radio value="90">90°</Radio><Radio value="270">270°</Radio></Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="去雾"><Switch /></Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'lens' && activeSideTab === 'privacy' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>隐私区域</Divider>
                                        <Form.Item label="是否启用隐私区域">
                                            <Switch checked={lensConfig.privacyEnabled} onChange={v => setLensConfig(p => ({...p, privacyEnabled: v}))} />
                                        </Form.Item>
                                        {lensConfig.privacyEnabled && (
                                        <Form.Item label="隐私区域数量">
                                            <Select defaultValue="1" style={{ width: 100 }}>
                                                <Option value="1">1</Option><Option value="2">2</Option><Option value="3">3</Option><Option value="4">4</Option>
                                            </Select>
                                        </Form.Item>
                                        )}
                                    </Form>
                                )}
                                {activeTab === 'lens' && activeSideTab === 'watermark' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>水印</Divider>
                                        <Form.Item label="是否启用水印">
                                            <Switch checked={lensConfig.watermarkEnabled} onChange={v => setLensConfig(p => ({...p, watermarkEnabled: v}))} />
                                        </Form.Item>
                                        {lensConfig.watermarkEnabled && (
                                        <Form.Item label="水印内容"><Input defaultValue="Camera-001" style={{ width: 200 }} /></Form.Item>
                                        )}
                                    </Form>
                                )}
                                {activeTab === 'lens' && activeSideTab === 'fisheye' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>鱼眼矫正</Divider>
                                        <Form.Item label="是否支持鱼眼矫正">
                                            <Switch checked={lensConfig.fisheyeEnabled} onChange={v => setLensConfig(p => ({...p, fisheyeEnabled: v}))} />
                                        </Form.Item>
                                        {lensConfig.fisheyeEnabled && (
                                        <Form.Item label="矫正模式">
                                            <Select defaultValue="0" style={{ width: 160 }}>
                                                <Option value="0">顶装模式</Option><Option value="1">壁装模式</Option><Option value="2">全景模式</Option>
                                            </Select>
                                        </Form.Item>
                                        )}
                                    </Form>
                                )}
                                {activeTab === 'lens' && activeSideTab === 'advanced' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>高级配置项</Divider>
                                        <Form.Item label="ROI智能编码"><Switch defaultChecked /></Form.Item>
                                        <Form.Item label="SVC可伸缩编码"><Switch /></Form.Item>
                                        <Form.Item label="最大I帧间隔"><InputNumber min={1} max={250} defaultValue={50} style={{ width: 120 }} /></Form.Item>
                                        <Form.Item label="GOP结构">
                                            <Select defaultValue="IP" style={{ width: 120 }}>
                                                <Option value="IP">IP</Option><Option value="IPP">IPP</Option>
                                            </Select>
                                        </Form.Item>
                                    </Form>
                                )}
                                {/* ═══ 麦克风配置 ═══ */}
                                {activeTab === 'mic' && activeSideTab === 'mic-param' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>麦克风参数配置</Divider>
                                        <Form.Item label="是否支持麦克风">
                                            <Radio.Group value={micConfig.micSupported} onChange={e => setMicConfig(p => ({...p, micSupported: e.target.value}))}>
                                                <Radio value="1">支持</Radio>
                                                <Radio value="0">不支持</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        {micConfig.micSupported === '1' && (<>
                                        <Form.Item label="麦克风类型">
                                            <Radio.Group value={micConfig.micType} onChange={e => setMicConfig(p => ({...p, micType: e.target.value}))}>
                                                <Radio value="0">内置</Radio><Radio value="1">外置</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="降噪开关">
                                            <Switch checked={micConfig.noiseReduction} onChange={v => setMicConfig(p => ({...p, noiseReduction: v}))} />
                                        </Form.Item>
                                        <Form.Item label="自动增益控制(AGC)">
                                            <Switch checked={micConfig.agc} onChange={v => setMicConfig(p => ({...p, agc: v}))} />
                                        </Form.Item>
                                        </>)}
                                    </Form>
                                )}
                                {activeTab === 'mic' && activeSideTab === 'audio-stream' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>音频码流配置</Divider>
                                        <Form.Item label="支持编码方式">
                                            <Checkbox.Group defaultValue={['AAC']}>
                                                <Space><Checkbox value="PCM">PCM</Checkbox><Checkbox value="G711A">G.711A</Checkbox><Checkbox value="G711U">G.711U</Checkbox><Checkbox value="AAC">AAC</Checkbox><Checkbox value="MP3">MP3</Checkbox></Space>
                                            </Checkbox.Group>
                                        </Form.Item>
                                        <Form.Item label="默认编码方式">
                                            <Select defaultValue="AAC" style={{ width: 120 }}>
                                                <Option value="PCM">PCM</Option><Option value="AAC">AAC</Option><Option value="MP3">MP3</Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item label="采样率">
                                            <Select defaultValue="16000" style={{ width: 160 }}>
                                                <Option value="8000">8000 Hz</Option><Option value="16000">16000 Hz</Option><Option value="32000">32000 Hz</Option><Option value="44100">44100 Hz</Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item label="声道数">
                                            <Radio.Group defaultValue="1">
                                                <Radio value="1">单声道</Radio><Radio value="2">双声道</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Form>
                                )}
                                {/* ═══ 屏显配置 ═══ */}
                                {activeTab === 'display' && activeSideTab === 'resolution' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>分辨率支持</Divider>
                                        <Form.Item label="是否支持屏显">
                                            <Radio.Group value={displayConfig.hasScreen} onChange={e => setDisplayConfig(p => ({...p, hasScreen: e.target.value}))}>
                                                <Radio value="1">支持</Radio><Radio value="0">不支持</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        {displayConfig.hasScreen === '1' && (
                                        <Form.Item label="支持分辨率">
                                            <Checkbox.Group defaultValue={['1280*720']}>
                                                <Space wrap>
                                                    <Checkbox value="320*240">320*240</Checkbox>
                                                    <Checkbox value="640*480">640*480</Checkbox>
                                                    <Checkbox value="1280*720">1280*720</Checkbox>
                                                    <Checkbox value="1920*1080">1920*1080</Checkbox>
                                                </Space>
                                            </Checkbox.Group>
                                        </Form.Item>
                                        )}
                                    </Form>
                                )}
                                {activeTab === 'display' && activeSideTab === 'screen-time' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>屏幕时间</Divider>
                                        <Form.Item label="屏幕休眠时间(秒)">
                                            <InputNumber min={10} max={3600} defaultValue={60} style={{ width: 160 }} /> 秒
                                        </Form.Item>
                                        <Form.Item label="息屏后点击唤醒"><Switch defaultChecked /></Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'display' && activeSideTab === 'decode' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>编码方式</Divider>
                                        <Form.Item label="支持编码格式">
                                            <Checkbox.Group defaultValue={['H.264']}>
                                                <Checkbox value="MJPEG">MJPEG</Checkbox><Checkbox value="H.264">H.264</Checkbox><Checkbox value="H.265">H.265</Checkbox>
                                            </Checkbox.Group>
                                        </Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'display' && activeSideTab === 'display-type' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>显示类型</Divider>
                                        <Form.Item label="支持显示内容">
                                            <Checkbox.Group defaultValue={['时间戳','设备名称']}>
                                                <Space wrap>
                                                    <Checkbox value="时间戳">时间戳</Checkbox>
                                                    <Checkbox value="设备名称">设备名称</Checkbox>
                                                    <Checkbox value="自定义文字">自定义文字</Checkbox>
                                                    <Checkbox value="星期">星期</Checkbox>
                                                </Space>
                                            </Checkbox.Group>
                                        </Form.Item>
                                        <Form.Item label="字体颜色">
                                            <Radio.Group defaultValue="white"><Radio value="white">白色</Radio><Radio value="black">黑色</Radio><Radio value="green">绿色</Radio></Radio.Group>
                                        </Form.Item>
                                    </Form>
                                )}
                                {/* ═══ 喇叭配置 ═══ */}
                                {activeTab === 'speaker' && activeSideTab === 'decode' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>编码方式</Divider>
                                        <Form.Item label="是否支持喇叭">
                                            <Radio.Group value={speakerConfig.hornSupported} onChange={e => setSpeakerConfig(p => ({...p, hornSupported: e.target.value}))}>
                                                <Radio value="1">支持</Radio><Radio value="0">不支持</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="支持编码方式">
                                            <Checkbox.Group defaultValue={['PCM','AAC']}>
                                                <Space><Checkbox value="PCM">PCM</Checkbox><Checkbox value="AAC">AAC</Checkbox><Checkbox value="MP3">MP3</Checkbox></Space>
                                            </Checkbox.Group>
                                        </Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'speaker' && activeSideTab === 'volume' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>音量调节</Divider>
                                        <Form.Item label="音量调节">
                                            <Radio.Group value={speakerConfig.setVolumeAbility} onChange={e => setSpeakerConfig(p => ({...p, setVolumeAbility: e.target.value}))}>
                                                <Radio value="1">支持</Radio><Radio value="0">不支持</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="默认音量">
                                            <InputNumber min={0} max={100} defaultValue={75} style={{ width: 120 }} /> %
                                        </Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'speaker' && activeSideTab === 'ringtone' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>自定义铃声</Divider>
                                        <Form.Item label="自定义铃声">
                                            <Radio.Group value={speakerConfig.ringToneAbility} onChange={e => setSpeakerConfig(p => ({...p, ringToneAbility: e.target.value}))}>
                                                <Radio value="1">支持</Radio><Radio value="0">不支持</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item label="提示音类型">
                                            <Select defaultValue="ding" style={{ width: 160 }}>
                                                <Option value="ding">叮咚</Option><Option value="voice">人声引导</Option><Option value="alarm">报警音</Option>
                                            </Select>
                                        </Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'speaker' && activeSideTab === 'bit-depth' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>采样位深</Divider>
                                        <Form.Item label="采样位深">
                                            <Radio.Group value={speakerConfig.bitDepth} onChange={e => setSpeakerConfig(p => ({...p, bitDepth: e.target.value}))}>
                                                <Radio value="16">16bit</Radio><Radio value="24">24bit</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'speaker' && activeSideTab === 'sample-rate' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>采样率</Divider>
                                        <Form.Item label="采样率">
                                            <Radio.Group value={speakerConfig.sampleRate} onChange={e => setSpeakerConfig(p => ({...p, sampleRate: e.target.value}))}>
                                                <Radio value="8000">8000（电话音质）</Radio><Radio value="16000">16000（语音识别常用）</Radio><Radio value="44100">44100（CD音质）</Radio><Radio value="48000">48000（专业音频常用）</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Form>
                                )}
                                {activeTab === 'speaker' && activeSideTab === 'channel' && (
                                    <Form layout="horizontal" labelCol={{ span: 5 }}>
                                        <Divider orientation="left" style={{ fontSize: '14px', margin: '0 0 20px 0' }}>声道数</Divider>
                                        <Form.Item label="声道数">
                                            <Radio.Group value={speakerConfig.channel} onChange={e => setSpeakerConfig(p => ({...p, channel: e.target.value}))}>
                                                <Radio value="1">单声道</Radio><Radio value="2">双声道</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Form>
                                )}
                            </div>
                        </div>

                        <div style={{ marginTop: 40 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                    <Title level={4} style={{ margin: 0 }}>标准能力 <Tooltip title="系统预定义的功能"><InfoCircleOutlined style={{ fontSize: 14, color: '#8c8c8c', marginLeft: 4 }} /></Tooltip></Title>
                                    {!isEcosystem && <Button type="primary" size="small">添加标准能力</Button>}
                                </div>
                                <Table columns={abilityColumns} dataSource={standardData} pagination={false} bordered size="middle" />

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 40, marginBottom: 16 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <Title level={4} style={{ margin: 0 }}>自定义能力 <Tooltip title="您所定义的每一个功能，都与固件、APP控制面板相关"><InfoCircleOutlined style={{ fontSize: 14, color: '#8c8c8c', marginLeft: 4 }} /></Tooltip></Title>
                                        <Text type="secondary" style={{ fontSize: '12px' }}>您所定义的每一个功能，都与固件、APP控制面板相关</Text>
                                    </div>
                                    {!isEcosystem && <Button type="primary" size="small">添加自定义能力</Button>}
                                </div>
                                <Table columns={abilityColumns} dataSource={customData} pagination={false} bordered size="middle" />
                            </div>
                    </div>
                )}

                {currentStep === 1 && (
                    <div style={{ padding: '0 24px 24px' }}>
                        <Table 
                            columns={[
                                { title: 'ID(AIIoTType)', dataIndex: 'id', key: 'id', width: 100,
                                    onCell: (record) => {
                                        if (record.id === '1000' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1000' && !record._mergeFirst) return { rowSpan: 0 };
                                        return {};
                                    },
                                    render: (t) => <Text code>{t}</Text> },
                                { title: '算法名称', dataIndex: 'name', key: 'name', width: 120,
                                    onCell: (record) => {
                                        if (record.id === '1000' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1000' && !record._mergeFirst) return { rowSpan: 0 };
                                        return {};
                                    },
                                    render: (t) => <Text strong>{t}</Text> },
                                { title: '算法描述', dataIndex: 'desc', key: 'desc', ellipsis: true,
                                    onCell: (record) => {
                                        if (record.id === '1000' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1000' && !record._mergeFirst) return { rowSpan: 0 };
                                        return {};
                                    } },
                                { title: '算法配置', key: 'props', width: 100,
                                    onCell: (record) => {
                                        if (record.id === '1000' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1000' && !record._mergeFirst) return { rowSpan: 0 };
                                        return {};
                                    },
                                    render: (_, record) => (['1021','1024','1088','1096','1098','1103','1104','1105','1106'].includes(record.id) ? null :
                                        <Button type="link" style={{ padding: 0 }} onClick={() => { setCurrentAlgo(record); setAlgoConfigDrawerVisible(true); }}>配置</Button>
                                    )},
                                { title: '关联事件', key: 'events', width: 100,
                                    onCell: (record) => {
                                        if (record.id === '1000' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1000' && !record._mergeFirst) return { rowSpan: 0 };
                                        return {};
                                    },
                                    render: (_, record) => (record.id === '1108' || record.id === '1114' ? null :
                                        <Button type="link" style={{ padding: 0 }} onClick={() => { setCurrentAlgo(record); setEventDrawerVisible(true); }}>配置</Button>
                                    )},
                                { title: '服务ID', dataIndex: 'service_id', key: 'service_id', width: 100, render: (t) => <Text code style={{ fontSize: 12 }}>{t}</Text> },
                                { title: '服务名称', key: 'svcName', width: 120, render: (_, r) => <Text>{r.service_name || r.name}</Text> },
                                { title: '服务描述', key: 'svcDesc', width: 150, ellipsis: true, render: (_, r) => <Text type="secondary">{r.service_desc || r.desc}</Text> },
                                { title: '是否支持', dataIndex: 'supported', key: 'supported', width: 80, render: (checked, record) => (
                                    <Switch checked={checked} size="small" onChange={(v) => {
                                        setAlgorithmData(prev => prev.map(a => a.key === record.key ? { ...a, supported: v, freeOpen: v ? a.freeOpen : false } : a));
                                    }} />
                                ) },
                                { title: '免开通', dataIndex: 'freeOpen', key: 'freeOpen', width: 120, render: (f, record) => (
                                    <Switch
                                        checked={f}
                                        disabled={!record.supported}
                                        checkedChildren="免开通"
                                        unCheckedChildren="需购买"
                                        size="small"
                                        onChange={(v) => {
                                            setAlgorithmData(prev => prev.map(a => a.key === record.key ? { ...a, freeOpen: v } : a));
                                        }}
                                    />
                                ) },
                            ]} 
                            dataSource={algorithmData.filter(a => a.id !== '1010')} 
                            pagination={false} 
                            bordered
                            size="middle"
                        />
                    </div>
                )}

                {currentStep === 2 && (
                    <div style={{ padding: '0 24px 24px' }}>
                        <Table 
                            columns={[
                                { title: 'ID(AIIoTType)', dataIndex: 'id', key: 'id', width: 100,
                                    onCell: (record) => {
                                        if (record.id === '1010' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1010' && !record._mergeFirst) return { rowSpan: 0 };
                                        if (record.id === '1063' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1063' && !record._mergeFirst) return { rowSpan: 0 };
                                        if (record.id === '1000' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1000' && !record._mergeFirst) return { rowSpan: 0 };
                                        return {};
                                    },
                                    render: (t) => <Text code>{t}</Text> },
                                { title: '算法名称', dataIndex: 'name', key: 'name', width: 140,
                                    onCell: (record) => {
                                        if (record.id === '1010' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1010' && !record._mergeFirst) return { rowSpan: 0 };
                                        if (record.id === '1063' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1063' && !record._mergeFirst) return { rowSpan: 0 };
                                        if (record.id === '1000' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1000' && !record._mergeFirst) return { rowSpan: 0 };
                                        return {};
                                    },
                                    render: (t) => <Text strong>{t}</Text> },
                                { title: '算法配置', key: 'props', width: 100,
                                    onCell: (record) => {
                                        if (record.id === '1010' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1010' && !record._mergeFirst) return { rowSpan: 0 };
                                        if (record.id === '1063' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1063' && !record._mergeFirst) return { rowSpan: 0 };
                                        if (record.id === '1000' && record._mergeFirst) return { rowSpan: 2 };
                                        if (record.id === '1000' && !record._mergeFirst) return { rowSpan: 0 };
                                        return {};
                                    },
                                    render: (_, record) => (
                                        <Button type="link" style={{ padding: 0 }}>配置</Button>
                                    )},
                                { title: '服务ID', dataIndex: 'service_id', key: 'service_id', width: 100, render: (t) => <Text code style={{ fontSize: 12 }}>{t}</Text> },
                                { title: '服务名称', dataIndex: 'name', key: 'name', width: 140, render: (t) => <Text strong>{t}</Text> },
                                { title: '服务描述', key: 'svcDesc', width: 180, ellipsis: true, render: (_, r) => <Text type="secondary">{r.desc}</Text> },
                                { title: '是否支持', dataIndex: 'supported', key: 'supported', width: 80, render: (checked) => <Switch defaultChecked={checked} size="small" /> },
                            ]} 
                            dataSource={[
                                { key: 'cloud_event', id: '1010', _mergeFirst: true, name: '云存录像', desc: '用于存储录制事件', service_id: '300010', supported: false },
                                { key: 'cloud_allday', id: '1010', name: '全天云存', desc: '用于存储视频回看', service_id: '300011', supported: false },
                                ...algorithmData.filter(a => a.id !== '1010'),
                                { key: 'timespace', id: '1100', name: '时光相册', desc: '生成精彩瞬间的时间轴视图', service_id: '300007', supported: false },
                                { key: 'alexa', id: '1063', _mergeFirst: true, name: '语音助手', desc: 'Amazon Alexa语音助手接入', service_id: '300005', supported: false },
                                { key: 'google', id: '1063', name: 'Google Home', desc: 'Google Home语音助手接入', service_id: '300006', supported: false },
                            ]} 
                            pagination={false} 
                            bordered
                            size="middle"
                        />
                    </div>
                )}

                {currentStep === 3 && (
                    <div style={{ padding: '0 24px 24px' }}>
                        <div style={{
                            backgroundColor: '#e6f7ff',
                            border: '1px solid #91d5ff',
                            padding: '8px 16px',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: 16
                        }}>
                            <InfoCircleOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                            <span style={{ fontSize: '12px' }}>开启语音助手后，用户可通过对应平台的智能音箱语音控制您的设备</span>
                        </div>
                        <Table
                            columns={voiceColumns}
                            dataSource={voiceData}
                            pagination={false}
                            size="middle"
                            bordered
                        />
                    </div>
                )}
            </Card>

            <Drawer
                title="编辑产品"
                width={560}
                onClose={onClose}
                open={drawerVisible}
                bodyStyle={{ paddingBottom: 80 }}
                footer={
                    <div style={{ textAlign: 'right', padding: '10px 16px' }}>
                        <Space>
                            <Button onClick={onClose}>取消</Button>
                            <Button type="primary" onClick={handleSave}>保存</Button>
                        </Space>
                    </div>
                }
            >
                <Form
                    form={createForm}
                    layout="horizontal"
                    labelCol={{ span: 5 }}
                    wrapperCol={{ span: 18 }}
                    labelAlign="right"
                >
                    <Form.Item
                        name="category"
                        label="产品类目"
                        rules={[{ required: true, message: '请选择产品类目' }]}
                    >
                        <Select placeholder="请选择产品类目">
                            <Select.OptGroup label="摄像机">
                                <Option value="camera_fix">固定摄像机</Option>
                                <Option value="camera_ptz">PTZ摄像机</Option>
                            </Select.OptGroup>
                            <Select.OptGroup label="网关类">
                                <Option value="gateway_hub">HUB</Option>
                            </Select.OptGroup>
                            <Select.OptGroup label="存储类">
                                <Option value="storage_nvr">NVR</Option>
                            </Select.OptGroup>
                        </Select>
                    </Form.Item>

                    {/* <Form.Item
                        name="netMode"
                        label="联网方式"
                        rules={[{ required: true, message: '请选择联网方式' }]}
                    >
                        <Select mode="multiple" placeholder="请选择联网方式">
                            <Option value="WIFI">WIFI</Option>
                            <Option value="4G">移动网络</Option>
                            <Option value="wired">有线网络</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="powerMode"
                        label="供电方式"
                        rules={[{ required: true, message: '请选择供电方式' }]}
                    >
                        <Select placeholder="请选择供电方式">
                            <Option value="normal">常电</Option>
                            <Option value="low">低功耗</Option>
                        </Select>
                    </Form.Item> */}

                    <Form.Item
                        name="name"
                        label="产品名称"
                        rules={[{ required: true, message: '请输入产品名称' }]}
                    >
                        <Input placeholder="请输入产品名称" maxLength={40} showCount />
                    </Form.Item>

                    <Form.Item
                        name="model"
                        label="产品型号"
                    >
                        <Input placeholder="请输入产品型号" maxLength={40} showCount />
                    </Form.Item>

                    <Form.Item
                        name="image"
                        label={
                            <span>
                                产品图 <InfoCircleOutlined style={{ color: '#8c8c8c' }} />
                            </span>
                        }
                    >
                        <Upload.Dragger name="files" action="/upload.do" maxCount={1}>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">拖拽图片到这或者点击上传</p>
                            <p className="ant-upload-hint">最多可上传1个文件</p>
                            <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: 8 }}>
                                请上传png、jpg、jpeg格式的文件,文件大小不超过20MB
                            </div>
                        </Upload.Dragger>
                    </Form.Item>

                    <Form.Item
                        name="description"
                        label="产品描述"
                    >
                        <TextArea rows={4} placeholder="请输入产品描述" maxLength={200} showCount />
                    </Form.Item>
                </Form>
            </Drawer>

            <Drawer
                title={null}
                width={1000}
                onClose={() => setEventDrawerVisible(false)}
                open={eventDrawerVisible}
                closable={false}
                bodyStyle={{ padding: 0 }}
                footer={
                    <div style={{ textAlign: 'right', padding: '10px 16px' }}>
                        <Space>
                            <Button onClick={() => setEventDrawerVisible(false)}>取消</Button>
                            <Button type="primary" onClick={() => setEventDrawerVisible(false)}>保存</Button>
                        </Space>
                    </div>
                }
            >
                <Tabs 
                    activeKey={activeEventTab}
                    onChange={setActiveEventTab}
                    items={[
                        { label: '平台事件', key: 'platform' },
                        { label: '自定义事件', key: 'custom' },
                    ]}
                    style={{ padding: '0 24px' }}
                />
                <div style={{ padding: '16px 24px' }}>
                    {activeEventTab === 'platform' ? (
                        <Table 
                            rowSelection={{ type: 'checkbox' }}
                            columns={eventColumns} 
                            dataSource={
                                currentAlgo?.id === '1000' 
                                    ? eventPlatformData.filter(item => ['100000', '100001'].includes(item.eventId))
                                    : currentAlgo?.id === '1003'
                                    ? eventPlatformData.filter(item => ['100001', '108300', '102900'].includes(item.eventId))
                                    : currentAlgo?.id === '1004'
                                    ? eventPlatformData.filter(item => ['100400'].includes(item.eventId))
                                    : currentAlgo?.id === '1016'
                                    ? eventPlatformData.filter(item => ['100021'].includes(item.eventId))
                                    : currentAlgo?.id === '1018'
                                    ? eventPlatformData.filter(item => ['100002'].includes(item.eventId))
                                    : currentAlgo?.id === '1021'
                                    ? eventPlatformData.filter(item => ['101201'].includes(item.eventId))
                                    : currentAlgo?.id === '1025'
                                    ? eventPlatformData.filter(item => ['102500'].includes(item.eventId))
                                    : currentAlgo?.id === '1028'
                                    ? eventPlatformData.filter(item => ['102800'].includes(item.eventId))
                                    : currentAlgo?.id === '1029'
                                    ? eventPlatformData.filter(item => ['102900'].includes(item.eventId))
                                    : currentAlgo?.id === '1037'
                                    ? eventPlatformData.filter(item => ['103700', '103701', '103702'].includes(item.eventId))
                                    : currentAlgo?.id === '1070'
                                    ? eventPlatformData.filter(item => ['107000', '107001'].includes(item.eventId))
                                    : currentAlgo?.id === '1079'
                                    ? eventPlatformData.filter(item => ['107900'].includes(item.eventId))
                                    : currentAlgo?.id === '1080'
                                    ? eventPlatformData.filter(item => ['108000'].includes(item.eventId))
                                    : currentAlgo?.id === '1082'
                                    ? eventPlatformData.filter(item => ['108200'].includes(item.eventId))
                                    : currentAlgo?.id === '1083'
                                    ? eventPlatformData.filter(item => ['108300'].includes(item.eventId))
                                    : currentAlgo?.id === '1086'
                                    ? eventPlatformData.filter(item => ['108600', '108601', '108602'].includes(item.eventId))
                                    : currentAlgo?.id === '1088'
                                    ? eventPlatformData.filter(item => ['100020'].includes(item.eventId))
                                    : currentAlgo?.id === '1090'
                                    ? eventPlatformData.filter(item => ['109000', '109001'].includes(item.eventId))
                                    : currentAlgo?.id === '1093'
                                    ? eventPlatformData.filter(item => ['109300', '109301', '109302'].includes(item.eventId))
                                    : currentAlgo?.id === '1098'
                                    ? eventPlatformData.filter(item => ['108300', '102900', '109600', '109700', '109800'].includes(item.eventId))
                                    : currentAlgo?.id === '1096'
                                    ? eventPlatformData.filter(item => ['109601', '109602', '109603', '109604', '109605', '109606'].includes(item.eventId))
                                    : currentAlgo?.id === '1103'
                                    ? eventPlatformData.filter(item => ['110300', '109701', '109702', '109703'].includes(item.eventId))
                                    : currentAlgo?.id === '1104'
                                    ? eventPlatformData.filter(item => ['110400', '102500', '102600'].includes(item.eventId))
                                    : currentAlgo?.id === '1105'
                                    ? eventPlatformData.filter(item => ['110500', '108901', '100017', '110900'].includes(item.eventId))
                                    : currentAlgo?.id === '1106'
                                    ? eventPlatformData.filter(item => ['110600', '102901', '102902', '102903', '102904', '102905', '102906'].includes(item.eventId))
                                    : currentAlgo?.id === '1111'
                                    ? eventPlatformData.filter(item => ['111100', '111101'].includes(item.eventId))
                                    : currentAlgo?.id === '1112'
                                    ? eventPlatformData.filter(item => ['100015'].includes(item.eventId))
                                    : currentAlgo?.id === '1024'
                                    ? eventPlatformData.filter(item => ['102400'].includes(item.eventId))
                                    : eventPlatformData
                            } 
                            pagination={false}
                            size="middle"
                        />
                    ) : (
                        <div>
                            <Button type="primary" style={{ marginBottom: 16 }}>添加事件</Button>
                            <Table 
                                columns={[
                                    { title: '事件ID', dataIndex: 'eventId', key: 'eventId' },
                                    { title: '事件名称', dataIndex: 'name', key: 'name' },
                                    { title: '事件描述', dataIndex: 'desc', key: 'desc' },
                                    { title: '报警联动', key: 'link' },
                                    { title: '操作', key: 'action' },
                                ]} 
                                dataSource={[]} 
                                locale={{ emptyText: '暂无数据' }}
                                size="middle"
                            />
                        </div>
                    )}
                </div>
            </Drawer>

            <Drawer
                title="算法配置"
                width={700}
                onClose={() => setAlgoConfigDrawerVisible(false)}
                open={algoConfigDrawerVisible}
                bodyStyle={{ paddingBottom: 80 }}
                footer={
                    <div style={{ textAlign: 'right', padding: '10px 16px' }}>
                        <Space>
                            <Button onClick={() => setAlgoConfigDrawerVisible(false)}>取消</Button>
                            <Button onClick={() => setAlgoConfigDrawerVisible(false)} type="primary">确定</Button>
                        </Space>
                    </div>
                }
            >
                {currentAlgo && (
                    <Form layout="horizontal" labelCol={{ span: 6 }} labelAlign="right">
                        {/* 特殊算法配置搬移 */}
                        {currentAlgo.id === '1003' && (
                            <>
                                <Divider orientation="left">PIR红外检测</Divider>
                                <Form.Item label="默认开关">
                                    <Switch 
                                        checked={aiLinkConfig.pir_detect.defaultOpen === '1'} 
                                        onChange={(checked) => setAiLinkConfig({
                                            ...aiLinkConfig, 
                                            pir_detect: { ...aiLinkConfig.pir_detect, defaultOpen: checked ? '1' : '0' }
                                        })}
                                    />
                                </Form.Item>

                                <Form.Item label="灵敏度">
                                    <Radio.Group 
                                        value={aiLinkConfig.pir_detect.sensitivity}
                                        onChange={(e) => setAiLinkConfig({
                                            ...aiLinkConfig, 
                                            pir_detect: { ...aiLinkConfig.pir_detect, sensitivity: e.target.value }
                                        })}
                                    >
                                        <Radio value="20">20(低)</Radio>
                                        <Radio value="40">40</Radio>
                                        <Radio value="60">60</Radio>
                                        <Radio value="80">80</Radio>
                                        <Radio value="100">100(高)</Radio>
                                    </Radio.Group>
                                </Form.Item>
                                <Form.Item label="智能追踪开关">
                                    <Switch 
                                        checked={aiLinkConfig.pir_detect.smartTrack === '1'} 
                                        onChange={(checked) => setAiLinkConfig({
                                            ...aiLinkConfig, 
                                            pir_detect: { ...aiLinkConfig.pir_detect, smartTrack: checked ? '1' : '0' }
                                        })}
                                    />
                                </Form.Item>
                                <Divider dashed />
                                <Form.Item label="声音报警 (1009)">
                                    <Switch 
                                        checked={aiLinkConfig.pir_detect.buzzerEnabled === '1'} 
                                        onChange={(checked) => setAiLinkConfig({
                                            ...aiLinkConfig, 
                                            pir_detect: { ...aiLinkConfig.pir_detect, buzzerEnabled: checked ? '1' : '0' }
                                        })}
                                    />
                                </Form.Item>
                                <Form.Item label="设备报警灯 (1030)">
                                    <Switch 
                                        checked={aiLinkConfig.pir_detect.alarmLightEnabled === '1'} 
                                        onChange={(checked) => setAiLinkConfig({
                                            ...aiLinkConfig, 
                                            pir_detect: { ...aiLinkConfig.pir_detect, alarmLightEnabled: checked ? '1' : '0' }
                                        })}
                                    />
                                </Form.Item>
                                <Form.Item label="自定义区域">
                                    <Switch 
                                        checked={false} 
                                        onChange={() => {}}
                                    />
                                </Form.Item>
                            </>
                        )}

                        {currentAlgo.id === '1108' && (
                            <>
                                <Divider orientation="left">GPS信息处理</Divider>
                                <Form.Item label="上报间隔 (秒)">
                                    <InputNumber
                                        defaultValue={5}
                                        style={{ width: 120 }}
                                        addonAfter="秒"
                                    />
                                </Form.Item>
                            </>
                        )}

                        {currentAlgo.id === '1111' && (
                            <>
                                <Divider orientation="left">鱼缸检测配置</Divider>
                                <Form.Item label="鱼类精彩瞬间">
                                    <Switch 
                                        checked={aiLinkConfig.fish_tank.highlightStatus === '1'} 
                                        onChange={(checked) => setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, highlightStatus: checked ? '1' : '0'}})}
                                    />
                                </Form.Item>
                                <Form.Item label="水温检测">
                                    <Switch 
                                        checked={aiLinkConfig.fish_tank.waterTemperatureStatus === '1'} 
                                        onChange={(checked) => setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, waterTemperatureStatus: checked ? '1' : '0'}})}
                                    />
                                </Form.Item>
                                <Form.Item label="水质检测">
                                    <Switch 
                                        checked={aiLinkConfig.fish_tank.waterQualityStatus === '1'} 
                                        onChange={(checked) => setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, waterQualityStatus: checked ? '1' : '0'}})}
                                    />
                                </Form.Item>
                                <Form.Item label="灵敏度">
                                    <Radio.Group 
                                        value={aiLinkConfig.fish_tank.sensitive}
                                        onChange={(e) => setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, sensitive: e.target.value}})}
                                    >
                                        <Radio value={25}>低</Radio>
                                        <Radio value={50}>中</Radio>
                                        <Radio value={75}>高</Radio>
                                    </Radio.Group>
                                </Form.Item>
                                <Form.Item label="鱼类种类">
                                    <Radio.Group 
                                        value={aiLinkConfig.fish_tank.fishSpecies}
                                        onChange={(e) => setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, fishSpecies: e.target.value}})}
                                    >
                                        <Radio value="0">未知</Radio>
                                        <Radio value="1">热水鱼</Radio>
                                        <Radio value="2">冷水鱼</Radio>
                                    </Radio.Group>
                                </Form.Item>
                                <Form.Item label="最低温度">
                                    <InputNumber 
                                        value={aiLinkConfig.fish_tank.minWaterTemperature} 
                                        addonAfter="℃"
                                        onChange={(val) => setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, minWaterTemperature: val}})}
                                    />
                                </Form.Item>
                                <Form.Item label="最高温度">
                                    <InputNumber 
                                        value={aiLinkConfig.fish_tank.maxWaterTemperature} 
                                        addonAfter="℃"
                                        onChange={(val) => setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, maxWaterTemperature: val}})}
                                    />
                                </Form.Item>
                                <Form.Item label="App展示">
                                    <Radio.Group 
                                        value={aiLinkConfig.fish_tank.showUnit}
                                        onChange={(e) => setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, showUnit: e.target.value}})}
                                    >
                                        <Radio value="1">摄氏度 ℃</Radio>
                                        <Radio value="2">华氏度 ℉</Radio>
                                    </Radio.Group>
                                </Form.Item>

                                <Divider dashed />
                                <Form.Item label="自定义区域">
                                    <Switch 
                                        checked={aiLinkConfig.fish_tank.detectAreaStatus === '1'} 
                                        onChange={(checked) => setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, detectAreaStatus: checked ? '1' : '0'}})}
                                    />
                                </Form.Item>
                                {aiLinkConfig.fish_tank.detectAreaStatus === '1' && (
                                    <div style={{ marginLeft: 40, padding: '16px', background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: '4px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16, alignItems: 'center' }}>
                                            <span style={{ fontWeight: 500 }}>区域配置</span>
                                            <Button 
                                                type="primary" size="small"
                                                onClick={() => {
                                                    const newList = [...aiLinkConfig.fish_tank.detectAreaList, { regionID: String(aiLinkConfig.fish_tank.detectAreaList.length + 1), points: [{ x: 0, y: 0 }] }];
                                                    setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, detectAreaList: newList}});
                                                }}
                                            >
                                                添加区域
                                            </Button>
                                        </div>
                                        {aiLinkConfig.fish_tank.detectAreaList.map((region, rIdx) => (
                                            <div key={rIdx} style={{ marginBottom: 20, padding: '12px', background: '#fff', borderRadius: '4px', border: '1px solid #eee' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                                                    <span>区域 ID: {region.regionID}</span>
                                                    <Space>
                                                        <Button type="link" size="small" onClick={() => {
                                                            const newList = [...aiLinkConfig.fish_tank.detectAreaList];
                                                            newList[rIdx].points.push({ x: 0, y: 0 });
                                                            setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, detectAreaList: newList}});
                                                        }}>添加点位</Button>
                                                        <Button type="link" danger size="small" onClick={() => {
                                                            const newList = aiLinkConfig.fish_tank.detectAreaList.filter((_, i) => i !== rIdx);
                                                            setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, detectAreaList: newList}});
                                                        }}>删除区域</Button>
                                                    </Space>
                                                </div>
                                                {region.points.map((point, pIdx) => (
                                                    <div key={pIdx} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                                        <span style={{ width: 50 }}>点 {pIdx + 1}:</span>
                                                        <InputNumber size="small" step={0.01} value={point.x} onChange={(val) => {
                                                            const newList = [...aiLinkConfig.fish_tank.detectAreaList];
                                                            newList[rIdx].points[pIdx].x = val;
                                                            setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, detectAreaList: newList}});
                                                        }} />
                                                        <span style={{ margin: '0 4px' }}>,</span>
                                                        <InputNumber size="small" step={0.01} value={point.y} onChange={(val) => {
                                                            const newList = [...aiLinkConfig.fish_tank.detectAreaList];
                                                            newList[rIdx].points[pIdx].y = val;
                                                            setAiLinkConfig({...aiLinkConfig, fish_tank: {...aiLinkConfig.fish_tank, detectAreaList: newList}});
                                                        }} />
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </>
                        )}

                        {currentAlgo.id === '1112' && (
                            <>
                                <Divider orientation="left">人脸检测配置</Divider>
                                <Form.Item label="人脸抓拍模式">
                                    <Radio.Group 
                                        value={aiLinkConfig.face_detect.captureMode}
                                        onChange={(e) => setAiLinkConfig({
                                            ...aiLinkConfig, 
                                            face_detect: { ...aiLinkConfig.face_detect, captureMode: e.target.value }
                                        })}
                                    >
                                        <Radio value="1">质量</Radio>
                                        <Radio value="2">快速</Radio>
                                    </Radio.Group>
                                </Form.Item>

                                {aiLinkConfig.face_detect.captureMode === '1' && (
                                    <div style={{ marginLeft: 40, padding: '12px', background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: '4px', marginBottom: 16 }}>
                                        <Form.Item label="置信度" style={{ marginBottom: 0 }}>
                                            <InputNumber 
                                                min={1} 
                                                max={100} 
                                                value={aiLinkConfig.face_detect.confidence} 
                                                onChange={(val) => setAiLinkConfig({
                                                    ...aiLinkConfig, 
                                                    face_detect: { ...aiLinkConfig.face_detect, confidence: val }
                                                })}
                                                style={{ width: 120 }} 
                                            />
                                        </Form.Item>
                                    </div>
                                )}

                                <Form.Item label="灵敏度">
                                    <Radio.Group 
                                        value={aiLinkConfig.face_detect.sensitive}
                                        onChange={(e) => setAiLinkConfig({
                                            ...aiLinkConfig, 
                                            face_detect: { ...aiLinkConfig.face_detect, sensitive: e.target.value }
                                        })}
                                    >
                                        <Radio value="25">低</Radio>
                                        <Radio value="50">中</Radio>
                                        <Radio value="75">高</Radio>
                                    </Radio.Group>
                                </Form.Item>

                                <Divider dashed />
                                <Form.Item label="自定义区域">
                                    <Switch 
                                        checked={aiLinkConfig.face_detect.customArea}
                                        onChange={(checked) => setAiLinkConfig({
                                            ...aiLinkConfig, 
                                            face_detect: { ...aiLinkConfig.face_detect, customArea: checked }
                                        })}
                                    />
                                </Form.Item>

                                {aiLinkConfig.face_detect.customArea && (
                                    <div style={{ padding: '0 20px' }}>
                                        {aiLinkConfig.face_detect.detectAreaList.map((area, areaIdx) => (
                                            <div key={areaIdx} style={{ marginBottom: 20, padding: 10, border: '1px dashed #ccc' }}>
                                                <div style={{ marginBottom: 10, fontWeight: 'bold' }}>区域 {areaIdx + 1} 坐标点:</div>
                                                {area.points.map((point, pointIdx) => (
                                                    <div key={pointIdx} style={{ display: 'flex', gap: 10, marginBottom: 8, alignItems: 'center' }}>
                                                        <span>点 {pointIdx + 1}:</span>
                                                        <InputNumber placeholder="X" value={point.x} onChange={(val) => {
                                                            const newList = [...aiLinkConfig.face_detect.detectAreaList];
                                                            newList[areaIdx].points[pointIdx].x = val;
                                                            setAiLinkConfig({...aiLinkConfig, face_detect: {...aiLinkConfig.face_detect, detectAreaList: newList}});
                                                        }} />
                                                        <InputNumber placeholder="Y" value={point.y} onChange={(val) => {
                                                            const newList = [...aiLinkConfig.face_detect.detectAreaList];
                                                            newList[areaIdx].points[pointIdx].y = val;
                                                            setAiLinkConfig({...aiLinkConfig, face_detect: {...aiLinkConfig.face_detect, detectAreaList: newList}});
                                                        }} />
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </>
                        )}

                        {currentAlgo.id === '1114' && (
                            <>
                                <Divider orientation="left">宠物喂食器配置</Divider>
                                <Form.Item 
                                    label="宠物喂食速度" 
                                    extra="设置值范围：1 ~ 10"
                                >
                                    <InputNumber 
                                        min={1} 
                                        max={10} 
                                        value={aiLinkConfig.pet_feeder.feedSpeed} 
                                        onChange={(val) => setAiLinkConfig({
                                            ...aiLinkConfig, 
                                            pet_feeder: { ...aiLinkConfig.pet_feeder, feedSpeed: val }
                                        })}
                                        style={{ width: 120 }} 
                                    />
                                </Form.Item>
                                <Form.Item 
                                    label="食物总量" 
                                    extra="设置值范围：0 ~ 100"
                                >
                                    <InputNumber 
                                        min={0} 
                                        max={100} 
                                        value={aiLinkConfig.pet_feeder.foodTotal} 
                                        onChange={(val) => setAiLinkConfig({
                                            ...aiLinkConfig, 
                                            pet_feeder: { ...aiLinkConfig.pet_feeder, foodTotal: val }
                                        })}
                                        style={{ width: 120 }} 
                                    />
                                </Form.Item>
                            </>
                        )}

                        {['1004', '1028', '1029', '1070', '1025', '1082', '1079', '1080', '1086', '1083', '1109'].includes(currentAlgo.id) && (
                            <>
                                <Divider orientation="left">
                                    {currentAlgo.id === '1004' ? '声音检测配置' : 
                                     currentAlgo.id === '1028' ? '哭声检测配置' : 
                                     currentAlgo.id === '1029' ? '宠物检测配置' : 
                                     currentAlgo.id === '1070' ? '离岗侦测配置' : 
                                     currentAlgo.id === '1025' ? '火焰检测配置' : 
                                     currentAlgo.id === '1082' ? '烟火侦测配置' : 
                                     currentAlgo.id === '1079' ? '区域闯入配置' : 
                                     currentAlgo.id === '1080' ? '区域离开配置' : 
                                     currentAlgo.id === '1083' ? '车辆侦测配置' : 
                                     currentAlgo.id === '1109' ? '包裹侦测配置' : '非机动车检测配置'}
                                </Divider>
                                <Form.Item label="间隔时间 (秒)">
                                    <InputNumber defaultValue={30} addonAfter="s" style={{ width: 150 }} />
                                </Form.Item>
                                <Form.Item label="灵敏度">
                                    <Radio.Group 
                                        value={
                                            currentAlgo.id === '1004' ? aiLinkConfig.sound_detect.sensitivity :
                                            currentAlgo.id === '1028' ? aiLinkConfig.cry_detect.sensitivity :
                                            currentAlgo.id === '1029' ? aiLinkConfig.pet_detect.sensitivity :
                                            currentAlgo.id === '1070' ? aiLinkConfig.offpost_detect.sensitivity :
                                            currentAlgo.id === '1025' ? aiLinkConfig.flame_detect.sensitivity :
                                            currentAlgo.id === '1082' ? aiLinkConfig.smoke_detect.sensitivity :
                                            ['1079', '1086', '1109'].includes(currentAlgo.id) ? aiLinkConfig.intrude_detect.sensitivity :
                                            currentAlgo.id === '1083' ? aiLinkConfig.sound_detect.sensitivity :
                                            aiLinkConfig.leave_detect.sensitivity
                                        }
                                        onChange={(e) => {
                                            const configKey = currentAlgo.id === '1004' ? 'sound_detect' : 
                                                            currentAlgo.id === '1028' ? 'cry_detect' : 
                                                            currentAlgo.id === '1029' ? 'pet_detect' : 
                                                            currentAlgo.id === '1070' ? 'offpost_detect' : 
                                                            currentAlgo.id === '1025' ? 'flame_detect' : 
                                                            currentAlgo.id === '1082' ? 'smoke_detect' : 
                                                            ['1079', '1086', '1109'].includes(currentAlgo.id) ? 'intrude_detect' : 
                                                            currentAlgo.id === '1083' ? 'sound_detect' : 'leave_detect';
                                            setAiLinkConfig({
                                                ...aiLinkConfig, 
                                                [configKey]: { ...aiLinkConfig[configKey], sensitivity: e.target.value }
                                            });
                                        }}
                                    >
                                        <Radio value="25">低</Radio>
                                        <Radio value="50">中</Radio>
                                        <Radio value="75">高</Radio>
                                    </Radio.Group>
                                </Form.Item>
                                
                                <Divider dashed />
                                <Form.Item label="声音报警 (1009)">
                                    <Switch 
                                        checked={
                                            (currentAlgo.id === '1004' ? aiLinkConfig.sound_detect.buzzerEnabled :
                                             currentAlgo.id === '1028' ? aiLinkConfig.cry_detect.buzzerEnabled :
                                             currentAlgo.id === '1029' ? aiLinkConfig.pet_detect.buzzerEnabled :
                                             currentAlgo.id === '1070' ? aiLinkConfig.offpost_detect.buzzerEnabled :
                                             currentAlgo.id === '1025' ? aiLinkConfig.flame_detect.buzzerEnabled :
                                             currentAlgo.id === '1082' ? aiLinkConfig.smoke_detect.buzzerEnabled :
                                             ['1079', '1086', '1109'].includes(currentAlgo.id) ? aiLinkConfig.intrude_detect.buzzerEnabled :
                                             currentAlgo.id === '1083' ? aiLinkConfig.sound_detect.buzzerEnabled :
                                             aiLinkConfig.leave_detect.buzzerEnabled) === '1'
                                        }
                                        onChange={(checked) => {
                                            const configKey = currentAlgo.id === '1004' ? 'sound_detect' : 
                                                            currentAlgo.id === '1028' ? 'cry_detect' : 
                                                            currentAlgo.id === '1029' ? 'pet_detect' : 
                                                            currentAlgo.id === '1070' ? 'offpost_detect' : 
                                                            currentAlgo.id === '1025' ? 'flame_detect' : 
                                                            currentAlgo.id === '1082' ? 'smoke_detect' : 
                                                            ['1079', '1086', '1109'].includes(currentAlgo.id) ? 'intrude_detect' : 
                                                            currentAlgo.id === '1083' ? 'sound_detect' : 'leave_detect';
                                            setAiLinkConfig({
                                                ...aiLinkConfig, 
                                                [configKey]: { ...aiLinkConfig[configKey], buzzerEnabled: checked ? '1' : '0' }
                                            });
                                        }}
                                    />
                                </Form.Item>
                                {(currentAlgo.id === '1004' ? aiLinkConfig.sound_detect.buzzerEnabled :
                                  currentAlgo.id === '1028' ? aiLinkConfig.cry_detect.buzzerEnabled :
                                  currentAlgo.id === '1029' ? aiLinkConfig.pet_detect.buzzerEnabled :
                                  currentAlgo.id === '1070' ? aiLinkConfig.offpost_detect.buzzerEnabled :
                                  currentAlgo.id === '1025' ? aiLinkConfig.flame_detect.buzzerEnabled :
                                  currentAlgo.id === '1082' ? aiLinkConfig.smoke_detect.buzzerEnabled :
                                  ['1079', '1086', '1109'].includes(currentAlgo.id) ? aiLinkConfig.intrude_detect.buzzerEnabled :
                                  currentAlgo.id === '1083' ? aiLinkConfig.sound_detect.buzzerEnabled :
                                  aiLinkConfig.leave_detect.buzzerEnabled) === '1' && (
                                    <div style={{ marginLeft: 40, padding: '12px', background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: '4px', marginBottom: 16 }}>
                                        <Form.Item label="循环次数" style={{ marginBottom: 16 }}>
                                            <InputNumber min={1} defaultValue={1} style={{ width: 120 }} />
                                        </Form.Item>
                                        <Form.Item label="音频文件" style={{ marginBottom: 0 }}>
                                            <Input placeholder="例如: 1.mp3" style={{ width: 200 }} />
                                        </Form.Item>
                                    </div>
                                )}

                                <Form.Item label="设备报警灯 (1030)">
                                    <Switch 
                                        checked={
                                            (currentAlgo.id === '1004' ? aiLinkConfig.sound_detect.alarmLightEnabled :
                                             currentAlgo.id === '1028' ? aiLinkConfig.cry_detect.alarmLightEnabled :
                                             currentAlgo.id === '1029' ? aiLinkConfig.pet_detect.alarmLightEnabled :
                                             currentAlgo.id === '1070' ? aiLinkConfig.offpost_detect.alarmLightEnabled :
                                             currentAlgo.id === '1025' ? aiLinkConfig.flame_detect.alarmLightEnabled :
                                             currentAlgo.id === '1082' ? aiLinkConfig.smoke_detect.alarmLightEnabled :
                                             ['1079', '1086', '1109'].includes(currentAlgo.id) ? aiLinkConfig.intrude_detect.alarmLightEnabled :
                                             currentAlgo.id === '1083' ? aiLinkConfig.sound_detect.alarmLightEnabled :
                                             aiLinkConfig.leave_detect.alarmLightEnabled) === '1'
                                        }
                                        onChange={(checked) => {
                                            const configKey = currentAlgo.id === '1004' ? 'sound_detect' : 
                                                            currentAlgo.id === '1028' ? 'cry_detect' : 
                                                            currentAlgo.id === '1029' ? 'pet_detect' : 
                                                            currentAlgo.id === '1070' ? 'offpost_detect' : 
                                                            currentAlgo.id === '1025' ? 'flame_detect' : 
                                                            currentAlgo.id === '1082' ? 'smoke_detect' : 
                                                            ['1079', '1086', '1109'].includes(currentAlgo.id) ? 'intrude_detect' : 
                                                            currentAlgo.id === '1083' ? 'sound_detect' : 'leave_detect';
                                            setAiLinkConfig({
                                                ...aiLinkConfig, 
                                                [configKey]: { ...aiLinkConfig[configKey], alarmLightEnabled: checked ? '1' : '0' }
                                            });
                                        }}
                                    />
                                </Form.Item>
                                {(currentAlgo.id === '1004' ? aiLinkConfig.sound_detect.alarmLightEnabled :
                                  currentAlgo.id === '1028' ? aiLinkConfig.cry_detect.alarmLightEnabled :
                                  currentAlgo.id === '1029' ? aiLinkConfig.pet_detect.alarmLightEnabled :
                                  currentAlgo.id === '1070' ? aiLinkConfig.offpost_detect.alarmLightEnabled :
                                  currentAlgo.id === '1025' ? aiLinkConfig.flame_detect.alarmLightEnabled :
                                  currentAlgo.id === '1082' ? aiLinkConfig.smoke_detect.alarmLightEnabled :
                                  ['1079', '1086', '1109'].includes(currentAlgo.id) ? aiLinkConfig.intrude_detect.alarmLightEnabled :
                                  currentAlgo.id === '1083' ? aiLinkConfig.sound_detect.alarmLightEnabled :
                                  aiLinkConfig.leave_detect.alarmLightEnabled) === '1' && (
                                    <div style={{ marginLeft: 40, padding: '12px', background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: '4px' }}>
                                        <Form.Item label="持续时长 (秒)" style={{ marginBottom: 0 }}>
                                            <InputNumber min={1} defaultValue={5} addonAfter="s" style={{ width: 150 }} />
                                        </Form.Item>
                                    </div>
                                )}

                                {['1079', '1080', '1086', '1109'].includes(currentAlgo.id) && (
                                    <>
                                        <Divider dashed />
                                        <Form.Item label="自定义区域">
                                            <Switch 
                                                checked={['1079', '1086', '1109'].includes(currentAlgo.id) ? aiLinkConfig.intrude_detect.customAreaEnabled : aiLinkConfig.leave_detect.customAreaEnabled}
                                                onChange={(checked) => {
                                                    const configKey = ['1079', '1086', '1109'].includes(currentAlgo.id) ? 'intrude_detect' : 'leave_detect';
                                                    setAiLinkConfig({
                                                        ...aiLinkConfig, 
                                                        [configKey]: { ...aiLinkConfig[configKey], customAreaEnabled: checked }
                                                    });
                                                }}
                                            />
                                        </Form.Item>
                                        {((['1079', '1086', '1109'].includes(currentAlgo.id) ? aiLinkConfig.intrude_detect.customAreaEnabled : aiLinkConfig.leave_detect.customAreaEnabled)) && (
                                            <div style={{ marginLeft: 40, padding: '16px', background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: '4px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16, alignItems: 'center' }}>
                                                    <span style={{ fontWeight: 500 }}>区域配置</span>
                                                    <Button 
                                                        type="primary" 
                                                        size="small"
                                                        onClick={() => {
                                                            const configKey = ['1079', '1086', '1109'].includes(currentAlgo.id) ? 'intrude_detect' : 'leave_detect';
                                                            const newRegions = [...aiLinkConfig[configKey].regions, { points: [{ x: 0, y: 0 }] }];
                                                            setAiLinkConfig({
                                                                ...aiLinkConfig,
                                                                [configKey]: { ...aiLinkConfig[configKey], regions: newRegions }
                                                            });
                                                        }}
                                                    >
                                                        添加区域
                                                    </Button>
                                                </div>
                                                {((['1079', '1086', '1109'].includes(currentAlgo.id) ? aiLinkConfig.intrude_detect.regions : aiLinkConfig.leave_detect.regions)).map((region, rIdx) => (
                                                    <div key={rIdx} style={{ marginBottom: 24, padding: '12px', background: '#fff', borderRadius: '4px', border: '1px solid #eee' }}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                                            <span style={{ color: '#666' }}>区域{rIdx + 1}</span>
                                                            <Space>
                                                                <Button 
                                                                    type="link" 
                                                                    size="small"
                                                                    onClick={() => {
                                                                        const configKey = ['1079', '1086', '1109'].includes(currentAlgo.id) ? 'intrude_detect' : 'leave_detect';
                                                                        const newRegions = [...aiLinkConfig[configKey].regions];
                                                                        newRegions[rIdx].points.push({ x: 0, y: 0 });
                                                                        setAiLinkConfig({
                                                                            ...aiLinkConfig,
                                                                            [configKey]: { ...aiLinkConfig[configKey], regions: newRegions }
                                                                        });
                                                                    }}
                                                                >
                                                                    添加点位
                                                                </Button>
                                                                <Button 
                                                                    type="link" 
                                                                    danger 
                                                                    size="small"
                                                                    onClick={() => {
                                                                        const configKey = ['1079', '1086', '1109'].includes(currentAlgo.id) ? 'intrude_detect' : 'leave_detect';
                                                                        const newRegions = aiLinkConfig[configKey].regions.filter((_, i) => i !== rIdx);
                                                                        setAiLinkConfig({
                                                                            ...aiLinkConfig,
                                                                            [configKey]: { ...aiLinkConfig[configKey], regions: newRegions }
                                                                        });
                                                                    }}
                                                                >
                                                                    删除区域
                                                                </Button>
                                                            </Space>
                                                        </div>
                                                        {region.points.map((point, pIdx) => (
                                                            <div key={pIdx} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                                                <span style={{ width: 60, fontSize: 13 }}>点位{pIdx + 1}:</span>
                                                                <span style={{ marginRight: 8 }}>x</span>
                                                                <InputNumber 
                                                                    size="small" 
                                                                    step={0.01} 
                                                                    value={point.x} 
                                                                    onChange={(val) => {
                                                                        const configKey = ['1079', '1086', '1109'].includes(currentAlgo.id) ? 'intrude_detect' : 'leave_detect';
                                                                        const newRegions = [...aiLinkConfig[configKey].regions];
                                                                        newRegions[rIdx].points[pIdx].x = val;
                                                                        setAiLinkConfig({
                                                                            ...aiLinkConfig,
                                                                            [configKey]: { ...aiLinkConfig[configKey], regions: newRegions }
                                                                        });
                                                                    }}
                                                                    style={{ width: 80 }} 
                                                                />
                                                                <span style={{ margin: '0 8px' }}>y</span>
                                                                <InputNumber 
                                                                    size="small" 
                                                                    step={0.01} 
                                                                    value={point.y} 
                                                                    onChange={(val) => {
                                                                        const configKey = ['1079', '1086', '1109'].includes(currentAlgo.id) ? 'intrude_detect' : 'leave_detect';
                                                                        const newRegions = [...aiLinkConfig[configKey].regions];
                                                                        newRegions[rIdx].points[pIdx].y = val;
                                                                        setAiLinkConfig({
                                                                            ...aiLinkConfig,
                                                                            [configKey]: { ...aiLinkConfig[configKey], regions: newRegions }
                                                                        });
                                                                    }}
                                                                    style={{ width: 80 }} 
                                                                />
                                                                <Button 
                                                                    type="link" 
                                                                    danger 
                                                                    size="small" 
                                                                    style={{ marginLeft: 'auto' }}
                                                                    onClick={() => {
                                                                        const configKey = ['1079', '1086', '1109'].includes(currentAlgo.id) ? 'intrude_detect' : 'leave_detect';
                                                                        const newRegions = [...aiLinkConfig[configKey].regions];
                                                                        newRegions[rIdx].points = newRegions[rIdx].points.filter((_, i) => i !== pIdx);
                                                                        setAiLinkConfig({
                                                                            ...aiLinkConfig,
                                                                            [configKey]: { ...aiLinkConfig[configKey], regions: newRegions }
                                                                        });
                                                                    }}
                                                                >
                                                                    删除
                                                                </Button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        )}

                        {currentAlgo.id === '1090' && (
                            <>
                                <Divider orientation="left">客流统计配置</Divider>
                                <Form.Item label="统计间隔">
                                    <InputNumber 
                                        min={1} 
                                        value={aiLinkConfig.flow_stat.interval} 
                                        addonAfter="秒" 
                                        style={{ width: 150 }}
                                        onChange={(val) => setAiLinkConfig({...aiLinkConfig, flow_stat: {...aiLinkConfig.flow_stat, interval: val}})}
                                    />
                                </Form.Item>
                                <Form.Item label="人数统计水印">
                                    <Switch 
                                        checked={aiLinkConfig.flow_stat.watermark} 
                                        onChange={(checked) => setAiLinkConfig({...aiLinkConfig, flow_stat: {...aiLinkConfig.flow_stat, watermark: checked}})}
                                    />
                                </Form.Item>
                                <Form.Item label="上报">
                                    <Switch 
                                        checked={aiLinkConfig.flow_stat.report} 
                                        onChange={(checked) => setAiLinkConfig({...aiLinkConfig, flow_stat: {...aiLinkConfig.flow_stat, report: checked}})}
                                    />
                                </Form.Item>
                                
                                <Divider dashed />
                                <div style={{ marginBottom: 16 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                        <span style={{ fontWeight: 500 }}>监控区域配置</span>
                                        <Button 
                                            type="primary" 
                                            size="small" 
                                            onClick={() => {
                                                const newRegions = [...aiLinkConfig.flow_stat.monitorRegions, { x: 0, y: 0 }];
                                                setAiLinkConfig({...aiLinkConfig, flow_stat: {...aiLinkConfig.flow_stat, monitorRegions: newRegions}});
                                            }}
                                        >
                                            添加坐标
                                        </Button>
                                    </div>
                                    <div style={{ padding: '12px', background: '#fafafa', borderRadius: '4px' }}>
                                        {aiLinkConfig.flow_stat.monitorRegions.map((point, idx) => (
                                            <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                                <span style={{ width: 60 }}>坐标{idx + 1}:</span>
                                                <span style={{ marginRight: 8 }}>x</span>
                                                <InputNumber 
                                                    size="small" step={0.01} value={point.x} 
                                                    onChange={(val) => {
                                                        const newRegions = [...aiLinkConfig.flow_stat.monitorRegions];
                                                        newRegions[idx].x = val;
                                                        setAiLinkConfig({...aiLinkConfig, flow_stat: {...aiLinkConfig.flow_stat, monitorRegions: newRegions}});
                                                    }}
                                                    style={{ width: 80 }} 
                                                />
                                                <span style={{ margin: '0 8px' }}>y</span>
                                                <InputNumber 
                                                    size="small" step={0.01} value={point.y} 
                                                    onChange={(val) => {
                                                        const newRegions = [...aiLinkConfig.flow_stat.monitorRegions];
                                                        newRegions[idx].y = val;
                                                        setAiLinkConfig({...aiLinkConfig, flow_stat: {...aiLinkConfig.flow_stat, monitorRegions: newRegions}});
                                                    }}
                                                    style={{ width: 80 }} 
                                                />
                                                <Button 
                                                    type="link" danger size="small" 
                                                    onClick={() => {
                                                        const newRegions = aiLinkConfig.flow_stat.monitorRegions.filter((_, i) => i !== idx);
                                                        setAiLinkConfig({...aiLinkConfig, flow_stat: {...aiLinkConfig.flow_stat, monitorRegions: newRegions}});
                                                    }}
                                                >
                                                    删除
                                                </Button>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                        <span style={{ fontWeight: 500 }}>门线坐标配置</span>
                                        <Button 
                                            type="primary" 
                                            size="small" 
                                            onClick={() => {
                                                const newLines = [...aiLinkConfig.flow_stat.doorLines, { x: 0, y: 0 }];
                                                setAiLinkConfig({...aiLinkConfig, flow_stat: {...aiLinkConfig.flow_stat, doorLines: newLines}});
                                            }}
                                        >
                                            添加坐标
                                        </Button>
                                    </div>
                                    <div style={{ padding: '12px', background: '#fafafa', borderRadius: '4px' }}>
                                        {aiLinkConfig.flow_stat.doorLines.map((point, idx) => (
                                            <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                                <span style={{ width: 60 }}>坐标{idx + 1}:</span>
                                                <span style={{ marginRight: 8 }}>x</span>
                                                <InputNumber 
                                                    size="small" step={0.01} value={point.x} 
                                                    onChange={(val) => {
                                                        const newLines = [...aiLinkConfig.flow_stat.doorLines];
                                                        newLines[idx].x = val;
                                                        setAiLinkConfig({...aiLinkConfig, flow_stat: {...aiLinkConfig.flow_stat, doorLines: newLines}});
                                                    }}
                                                    style={{ width: 80 }} 
                                                />
                                                <span style={{ margin: '0 8px' }}>y</span>
                                                <InputNumber 
                                                    size="small" step={0.01} value={point.y} 
                                                    onChange={(val) => {
                                                        const newLines = [...aiLinkConfig.flow_stat.doorLines];
                                                        newLines[idx].y = val;
                                                        setAiLinkConfig({...aiLinkConfig, flow_stat: {...aiLinkConfig.flow_stat, doorLines: newLines}});
                                                    }}
                                                    style={{ width: 80 }} 
                                                />
                                                <Button 
                                                    type="link" danger size="small" 
                                                    onClick={() => {
                                                        const newLines = aiLinkConfig.flow_stat.doorLines.filter((_, i) => i !== idx);
                                                        setAiLinkConfig({...aiLinkConfig, flow_stat: {...aiLinkConfig.flow_stat, doorLines: newLines}});
                                                    }}
                                                >
                                                    删除
                                                </Button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}

                        {currentAlgo.id === '1093' && (
                            <>
                                <Divider orientation="left">离线监控配置</Divider>
                                <Form.Item label="后台存储事件">
                                    <Radio.Group 
                                        value={aiLinkConfig.offline_monitor.storageEnabled ? '1' : '0'}
                                        onChange={(e) => setAiLinkConfig({
                                            ...aiLinkConfig, 
                                            offline_monitor: { storageEnabled: e.target.value === '1' }
                                        })}
                                    >
                                        <Radio value="1">是</Radio>
                                        <Radio value="0">否</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </>
                        )}

                        {currentAlgo.id === '1018' && (
                            <>
                                <Divider orientation="left">人脸识别算法配置</Divider>
                                <div style={{ backgroundColor: '#fafafa', padding: '24px 16px', borderRadius: 8 }}>
                                    <Form
                                        layout="horizontal"
                                        labelCol={{ span: 10 }}
                                        wrapperCol={{ span: 14 }}
                                        labelAlign="right"
                                    >
                                        <Row gutter={[32, 0]}>
                                            <Col span={12}>
                                                <Form.Item label="识别能力">
                                                    <Select 
                                                        value={aiLinkConfig.ai_face.recogType} 
                                                        style={{ width: '100%' }}
                                                        onChange={(val) => setAiLinkConfig({...aiLinkConfig, ai_face: {recogType: val}})}
                                                    >
                                                        <Option value="0">不识别</Option>
                                                        <Option value="1">端侧识别</Option>
                                                        <Option value="2">云端识别</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item label="底库最大图片数量">
                                                    <InputNumber min={0} defaultValue={0} style={{ width: '100%' }} disabled={aiLinkConfig.ai_face.recogType === '0'} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item label="自动录入开关">
                                                    <Radio.Group defaultValue="1" disabled={aiLinkConfig.ai_face.recogType === '0'}>
                                                        <Radio value="1">开</Radio>
                                                        <Radio value="0">关</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item label="默认打开图片入库">
                                                    <Radio.Group defaultValue="1" disabled={aiLinkConfig.ai_face.recogType === '0'}>
                                                        <Radio value="1">开</Radio>
                                                        <Radio value="0">关</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item label="入库相似度">
                                                    <InputNumber min={0} max={100} defaultValue={40} style={{ width: '100%' }} disabled={aiLinkConfig.ai_face.recogType === '0'} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item label="入库质量">
                                                    <InputNumber min={0} max={100} defaultValue={80} style={{ width: '100%' }} disabled={aiLinkConfig.ai_face.recogType === '0'} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item label="入库宽/高">
                                                    <Space>
                                                        <InputNumber defaultValue={240} style={{ width: '70px' }} disabled={aiLinkConfig.ai_face.recogType === '0'} />
                                                        <span style={{ color: '#ccc' }}>/</span>
                                                        <InputNumber defaultValue={240} style={{ width: '70px' }} disabled={aiLinkConfig.ai_face.recogType === '0'} />
                                                    </Space>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                            </>
                        )}

                        {currentAlgo.id === '1037' && (
                            <>
                                <Divider orientation="left">呼叫服务算法配置</Divider>
                                <div style={{ backgroundColor: '#fafafa', padding: '24px 16px', borderRadius: 8 }}>
                                    <Form
                                        layout="horizontal"
                                        labelCol={{ span: 10 }}
                                        wrapperCol={{ span: 14 }}
                                        labelAlign="right"
                                    >
                                        <Row gutter={[32, 0]}>
                                            <Col span={12}>
                                                <Form.Item label="一键呼叫">
                                                    <Radio.Group 
                                                        value={aiLinkConfig.oneKeyCall.supported}
                                                        onChange={(e) => setAiLinkConfig({...aiLinkConfig, oneKeyCall: {supported: e.target.value}})}
                                                    >
                                                        <Radio value="1">支持</Radio>
                                                        <Radio value="0">不支持</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item label="手势呼叫">
                                                    <Radio.Group 
                                                        value={aiLinkConfig.gestureCall.supported}
                                                        onChange={(e) => setAiLinkConfig({...aiLinkConfig, gestureCall: {supported: e.target.value}})}
                                                    >
                                                        <Radio value="1">支持</Radio>
                                                        <Radio value="0">不支持</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </Col>
                                            {aiLinkConfig.gestureCall.supported === '1' && (
                                                <Col span={24}>
                                                    <Form.Item label="手势具体配置" labelCol={{ span: 5 }}>
                                                        <div style={{ 
                                                            display: 'grid', 
                                                            gridTemplateColumns: 'repeat(4, 1fr)', 
                                                            gap: '16px', 
                                                            padding: 16, 
                                                            border: '1px solid #f0f0f0',
                                                            backgroundColor: '#fff'
                                                        }}>
                                                            {['挥手', '嘘', '比心', 'OK', '上八', '上指', '下八', '下指'].map(item => (
                                                                <div key={item}><Text style={{ fontSize: '12px' }}>{item}: </Text><Switch size="small" /></div>
                                                            ))}
                                                        </div>
                                                    </Form.Item>
                                                </Col>
                                            )}
                                        </Row>
                                    </Form>
                                </div>
                            </>
                        )}

                        <Divider>能力绑定</Divider>
                        <div style={{ marginBottom: 16 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                <span>标准能力 <Tooltip title="系统预定义的功能"><InfoCircleOutlined style={{ color: '#ccc' }} /></Tooltip></span>
                                {!isEcosystem && <Button type="primary" size="small">添加标准能力</Button>}
                            </div>
                            <Table 
                                columns={[
                                    { title: '类型', dataIndex: 'type', key: 'type' },
                                    { title: '能力名称', dataIndex: 'name', key: 'name' },
                                    { title: '能力标识', dataIndex: 'id', key: 'id' },
                                    { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
                                    { title: '数据定义', dataIndex: 'definition', key: 'definition' },
                                    { title: '描述', dataIndex: 'desc', key: 'desc' },
                                    { title: '所属模块', dataIndex: 'module', key: 'module' },
                                    { title: '操作', key: 'action' },
                                ]} 
                                dataSource={[]} 
                                pagination={false}
                                bordered
                                size="small"
                                locale={{ emptyText: '暂无数据' }}
                            />
                        </div>

                        <div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                <Space>
                                    <span>自定义能力 <Tooltip title="用户定义的功能"><InfoCircleOutlined style={{ color: '#ccc' }} /></Tooltip></span>
                                    <Text type="secondary" style={{ fontSize: '12px' }}>您所定义的每一个功能，都与固件、APP控制台面板相关</Text>
                                </Space>
                                {!isEcosystem && <Button type="primary" size="small">添加自定义能力</Button>}
                            </div>
                            <Table 
                                columns={[
                                    { title: '类型', dataIndex: 'type', key: 'type' },
                                    { title: '能力名称', dataIndex: 'name', key: 'name' },
                                    { title: '能力标识', dataIndex: 'id', key: 'id' },
                                    { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
                                    { title: '数据定义', dataIndex: 'definition', key: 'definition' },
                                    { title: '描述', dataIndex: 'desc', key: 'desc' },
                                    { title: '所属模块', dataIndex: 'module', key: 'module' },
                                    { title: '操作', key: 'action' },
                                ]} 
                                dataSource={[]} 
                                pagination={false}
                                bordered
                                size="small"
                                locale={{ emptyText: '暂无数据' }}
                            />
                        </div>
                    </Form>
                )}
            </Drawer>
        </div>
    );
};

export default ProductDetail;
